/**
 * Icon Library - Auto-generated Icon Registry
 *
 * Total Icons: 1487
 * Sources:
 * - tf2d2/icons (AWS, Azure, GCP - official SVGs)
 * - mingrammer/diagrams (K8s, Programming, Generic, OnPrem - PNGs)
 *
 * @generated - DO NOT EDIT MANUALLY
 * Run 'npm run generate:icons' to regenerate this file
 */

export type IconProvider = 'aws' | 'azure' | 'gcp' | 'k8s' | 'programming' | 'generic' | 'onprem';

export type IconFormat = 'svg' | 'png';

export interface IconDefinition {
  id: string;
  name: string;
  provider: IconProvider;
  category: string;
  path: string;
  format: IconFormat;
  tags: string[];
}

// ============================================================================
// Provider Metadata
// ============================================================================

export const PROVIDER_METADATA = {
  aws: {
    name: 'AWS',
    color: '#FF9900',
    description: 'Amazon Web Services',
    iconCount: 332,
  },
  azure: {
    name: 'Azure',
    color: '#0078D4',
    description: 'Microsoft Azure',
    iconCount: 619,
  },
  gcp: {
    name: 'GCP',
    color: '#4285F4',
    description: 'Google Cloud Platform',
    iconCount: 216,
  },
  k8s: {
    name: 'Kubernetes',
    color: '#326CE5',
    description: 'Kubernetes',
    iconCount: 46,
  },
  programming: {
    name: 'Programming',
    color: '#6B7280',
    description: 'Programming Languages & Frameworks',
    iconCount: 74,
  },
  generic: {
    name: 'Generic',
    color: '#6B7280',
    description: 'Generic Infrastructure Icons',
    iconCount: 27,
  },
  onprem: {
    name: 'On-Premises',
    color: '#6B7280',
    description: 'On-Premises Infrastructure',
    iconCount: 173,
  },
} as const;

// ============================================================================
// Icon Registry (1487 icons)
// ============================================================================

export const ICON_REGISTRY: Record<string, IconDefinition> = {
  // AWS (332 icons)
  'aws-alexa-for-business': {
    "id": "aws-alexa-for-business",
    "name": "Alexa For Business",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/alexa-for-business.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-api-gateway': {
    "id": "aws-amazon-api-gateway",
    "name": "Amazon Api Gateway",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-api-gateway.svg",
    "format": "svg",
    "tags": [
      "aws",
      "api"
    ]
  },
  'aws-amazon-appflow': {
    "id": "aws-amazon-appflow",
    "name": "Amazon Appflow",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-appflow.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-appstream': {
    "id": "aws-amazon-appstream",
    "name": "Amazon Appstream",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-appstream.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-athena': {
    "id": "aws-amazon-athena",
    "name": "Amazon Athena",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-athena.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  // ... 327 more aws icons
  'aws-amazon-augmented-ai-a2i': {
    "id": "aws-amazon-augmented-ai-a2i",
    "name": "Amazon Augmented Ai A2i",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-augmented-ai-a2i.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-aurora': {
    "id": "aws-amazon-aurora",
    "name": "Amazon Aurora",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-aurora.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-braket': {
    "id": "aws-amazon-braket",
    "name": "Amazon Braket",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-braket.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-chime-sdk': {
    "id": "aws-amazon-chime-sdk",
    "name": "Amazon Chime Sdk",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-chime-sdk.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-chime': {
    "id": "aws-amazon-chime",
    "name": "Amazon Chime",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-chime.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-cloud-directory': {
    "id": "aws-amazon-cloud-directory",
    "name": "Amazon Cloud Directory",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-cloud-directory.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-cloudfront': {
    "id": "aws-amazon-cloudfront",
    "name": "Amazon Cloudfront",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-cloudfront.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-cloudsearch': {
    "id": "aws-amazon-cloudsearch",
    "name": "Amazon Cloudsearch",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-cloudsearch.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-cloudwatch': {
    "id": "aws-amazon-cloudwatch",
    "name": "Amazon Cloudwatch",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-cloudwatch.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-codecatalyst': {
    "id": "aws-amazon-codecatalyst",
    "name": "Amazon Codecatalyst",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-codecatalyst.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-codeguru': {
    "id": "aws-amazon-codeguru",
    "name": "Amazon Codeguru",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-codeguru.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-codewhisperer': {
    "id": "aws-amazon-codewhisperer",
    "name": "Amazon Codewhisperer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-codewhisperer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-cognito': {
    "id": "aws-amazon-cognito",
    "name": "Amazon Cognito",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-cognito.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-comprehend-medical': {
    "id": "aws-amazon-comprehend-medical",
    "name": "Amazon Comprehend Medical",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-comprehend-medical.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-comprehend': {
    "id": "aws-amazon-comprehend",
    "name": "Amazon Comprehend",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-comprehend.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-connect': {
    "id": "aws-amazon-connect",
    "name": "Amazon Connect",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-connect.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-corretto': {
    "id": "aws-amazon-corretto",
    "name": "Amazon Corretto",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-corretto.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-datazone': {
    "id": "aws-amazon-datazone",
    "name": "Amazon Datazone",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-datazone.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-detective': {
    "id": "aws-amazon-detective",
    "name": "Amazon Detective",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-detective.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-devops-guru': {
    "id": "aws-amazon-devops-guru",
    "name": "Amazon Devops Guru",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-devops-guru.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-documentdb': {
    "id": "aws-amazon-documentdb",
    "name": "Amazon Documentdb",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-documentdb.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-amazon-dynamodb': {
    "id": "aws-amazon-dynamodb",
    "name": "Amazon Dynamodb",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-dynamodb.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-amazon-ec2-auto-scaling': {
    "id": "aws-amazon-ec2-auto-scaling",
    "name": "Amazon Ec2 Auto Scaling",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-ec2-auto-scaling.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },
  'aws-amazon-ec2-image-builder': {
    "id": "aws-amazon-ec2-image-builder",
    "name": "Amazon Ec2 Image Builder",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-ec2-image-builder.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },
  'aws-amazon-ec2': {
    "id": "aws-amazon-ec2",
    "name": "Amazon Ec2",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-ec2.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },
  'aws-amazon-ecs-anywhere': {
    "id": "aws-amazon-ecs-anywhere",
    "name": "Amazon Ecs Anywhere",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-ecs-anywhere.svg",
    "format": "svg",
    "tags": [
      "aws",
      "container"
    ]
  },
  'aws-amazon-efs': {
    "id": "aws-amazon-efs",
    "name": "Amazon Efs",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-efs.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-eks-anywhere': {
    "id": "aws-amazon-eks-anywhere",
    "name": "Amazon Eks Anywhere",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-eks-anywhere.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-eks-cloud': {
    "id": "aws-amazon-eks-cloud",
    "name": "Amazon Eks Cloud",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-eks-cloud.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-eks-distro': {
    "id": "aws-amazon-eks-distro",
    "name": "Amazon Eks Distro",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-eks-distro.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-elastic-block-store': {
    "id": "aws-amazon-elastic-block-store",
    "name": "Amazon Elastic Block Store",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-block-store.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-elastic-container-registry': {
    "id": "aws-amazon-elastic-container-registry",
    "name": "Amazon Elastic Container Registry",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-container-registry.svg",
    "format": "svg",
    "tags": [
      "aws",
      "container"
    ]
  },
  'aws-amazon-elastic-container-service': {
    "id": "aws-amazon-elastic-container-service",
    "name": "Amazon Elastic Container Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-container-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "container"
    ]
  },
  'aws-amazon-elastic-inference': {
    "id": "aws-amazon-elastic-inference",
    "name": "Amazon Elastic Inference",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-inference.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-elastic-kubernetes-service': {
    "id": "aws-amazon-elastic-kubernetes-service",
    "name": "Amazon Elastic Kubernetes Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-kubernetes-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "kubernetes"
    ]
  },
  'aws-amazon-elastic-transcoder': {
    "id": "aws-amazon-elastic-transcoder",
    "name": "Amazon Elastic Transcoder",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elastic-transcoder.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-elasticache': {
    "id": "aws-amazon-elasticache",
    "name": "Amazon Elasticache",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-elasticache.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-emr': {
    "id": "aws-amazon-emr",
    "name": "Amazon Emr",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-emr.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-eventbridge': {
    "id": "aws-amazon-eventbridge",
    "name": "Amazon Eventbridge",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-eventbridge.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-file-cache': {
    "id": "aws-amazon-file-cache",
    "name": "Amazon File Cache",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-file-cache.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-finspace': {
    "id": "aws-amazon-finspace",
    "name": "Amazon Finspace",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-finspace.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-forecast': {
    "id": "aws-amazon-forecast",
    "name": "Amazon Forecast",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-forecast.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fraud-detector': {
    "id": "aws-amazon-fraud-detector",
    "name": "Amazon Fraud Detector",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fraud-detector.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fsx-for-lustre': {
    "id": "aws-amazon-fsx-for-lustre",
    "name": "Amazon Fsx For Lustre",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fsx-for-lustre.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fsx-for-netapp-ontap': {
    "id": "aws-amazon-fsx-for-netapp-ontap",
    "name": "Amazon Fsx For Netapp Ontap",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fsx-for-netapp-ontap.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fsx-for-openzfs': {
    "id": "aws-amazon-fsx-for-openzfs",
    "name": "Amazon Fsx For Openzfs",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fsx-for-openzfs.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fsx-for-wfs': {
    "id": "aws-amazon-fsx-for-wfs",
    "name": "Amazon Fsx For Wfs",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fsx-for-wfs.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-fsx': {
    "id": "aws-amazon-fsx",
    "name": "Amazon Fsx",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-fsx.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-gamelift': {
    "id": "aws-amazon-gamelift",
    "name": "Amazon Gamelift",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-gamelift.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-gamesparks': {
    "id": "aws-amazon-gamesparks",
    "name": "Amazon Gamesparks",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-gamesparks.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-genomics-cli': {
    "id": "aws-amazon-genomics-cli",
    "name": "Amazon Genomics Cli",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-genomics-cli.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-guardduty': {
    "id": "aws-amazon-guardduty",
    "name": "Amazon Guardduty",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-guardduty.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-healthlake': {
    "id": "aws-amazon-healthlake",
    "name": "Amazon Healthlake",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-healthlake.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-honeycode': {
    "id": "aws-amazon-honeycode",
    "name": "Amazon Honeycode",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-honeycode.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-inspector': {
    "id": "aws-amazon-inspector",
    "name": "Amazon Inspector",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-inspector.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-interactive-video-service': {
    "id": "aws-amazon-interactive-video-service",
    "name": "Amazon Interactive Video Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-interactive-video-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kendra': {
    "id": "aws-amazon-kendra",
    "name": "Amazon Kendra",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kendra.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-keyspaces': {
    "id": "aws-amazon-keyspaces",
    "name": "Amazon Keyspaces",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-keyspaces.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis-data-analytics': {
    "id": "aws-amazon-kinesis-data-analytics",
    "name": "Amazon Kinesis Data Analytics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis-data-analytics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis-data-firehose': {
    "id": "aws-amazon-kinesis-data-firehose",
    "name": "Amazon Kinesis Data Firehose",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis-data-firehose.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis-data-streams': {
    "id": "aws-amazon-kinesis-data-streams",
    "name": "Amazon Kinesis Data Streams",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis-data-streams.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis-video-streams-2': {
    "id": "aws-amazon-kinesis-video-streams-2",
    "name": "Amazon Kinesis Video Streams 2",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis-video-streams-2.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis-video-streams': {
    "id": "aws-amazon-kinesis-video-streams",
    "name": "Amazon Kinesis Video Streams",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis-video-streams.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-kinesis': {
    "id": "aws-amazon-kinesis",
    "name": "Amazon Kinesis",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-kinesis.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lex': {
    "id": "aws-amazon-lex",
    "name": "Amazon Lex",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lex.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lightsail-for-research': {
    "id": "aws-amazon-lightsail-for-research",
    "name": "Amazon Lightsail For Research",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lightsail-for-research.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lightsail': {
    "id": "aws-amazon-lightsail",
    "name": "Amazon Lightsail",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lightsail.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-location-service': {
    "id": "aws-amazon-location-service",
    "name": "Amazon Location Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-location-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lookout-for-equipment': {
    "id": "aws-amazon-lookout-for-equipment",
    "name": "Amazon Lookout For Equipment",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lookout-for-equipment.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lookout-for-metrics': {
    "id": "aws-amazon-lookout-for-metrics",
    "name": "Amazon Lookout For Metrics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lookout-for-metrics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-lookout-for-vision': {
    "id": "aws-amazon-lookout-for-vision",
    "name": "Amazon Lookout For Vision",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-lookout-for-vision.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-macie': {
    "id": "aws-amazon-macie",
    "name": "Amazon Macie",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-macie.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-managed-blockchain': {
    "id": "aws-amazon-managed-blockchain",
    "name": "Amazon Managed Blockchain",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-managed-blockchain.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-managed-grafana': {
    "id": "aws-amazon-managed-grafana",
    "name": "Amazon Managed Grafana",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-managed-grafana.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-managed-service-for-prometheus': {
    "id": "aws-amazon-managed-service-for-prometheus",
    "name": "Amazon Managed Service For Prometheus",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-managed-service-for-prometheus.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-managed-streaming-for-apache-kafka': {
    "id": "aws-amazon-managed-streaming-for-apache-kafka",
    "name": "Amazon Managed Streaming For Apache Kafka",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-managed-streaming-for-apache-kafka.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-managed-workflows-for-apache-airflow': {
    "id": "aws-amazon-managed-workflows-for-apache-airflow",
    "name": "Amazon Managed Workflows For Apache Airflow",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-managed-workflows-for-apache-airflow.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-memorydb-for-redis': {
    "id": "aws-amazon-memorydb-for-redis",
    "name": "Amazon Memorydb For Redis",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-memorydb-for-redis.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-amazon-monitron': {
    "id": "aws-amazon-monitron",
    "name": "Amazon Monitron",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-monitron.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-mq': {
    "id": "aws-amazon-mq",
    "name": "Amazon Mq",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-mq.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-neptune': {
    "id": "aws-amazon-neptune",
    "name": "Amazon Neptune",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-neptune.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-nimble-studio': {
    "id": "aws-amazon-nimble-studio",
    "name": "Amazon Nimble Studio",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-nimble-studio.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-omics': {
    "id": "aws-amazon-omics",
    "name": "Amazon Omics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-omics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-opensearch-service': {
    "id": "aws-amazon-opensearch-service",
    "name": "Amazon Opensearch Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-opensearch-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-personalize': {
    "id": "aws-amazon-personalize",
    "name": "Amazon Personalize",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-personalize.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-pinpoint-apis': {
    "id": "aws-amazon-pinpoint-apis",
    "name": "Amazon Pinpoint Apis",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-pinpoint-apis.svg",
    "format": "svg",
    "tags": [
      "aws",
      "api"
    ]
  },
  'aws-amazon-pinpoint': {
    "id": "aws-amazon-pinpoint",
    "name": "Amazon Pinpoint",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-pinpoint.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-polly': {
    "id": "aws-amazon-polly",
    "name": "Amazon Polly",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-polly.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-quantum-ledger-database': {
    "id": "aws-amazon-quantum-ledger-database",
    "name": "Amazon Quantum Ledger Database",
    "provider": "aws",
    "category": "database",
    "path": "/icons/aws/amazon-quantum-ledger-database.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-amazon-quicksight': {
    "id": "aws-amazon-quicksight",
    "name": "Amazon Quicksight",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-quicksight.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-rds-on-vmware': {
    "id": "aws-amazon-rds-on-vmware",
    "name": "Amazon Rds On Vmware",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-rds-on-vmware.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server",
      "database"
    ]
  },
  'aws-amazon-rds': {
    "id": "aws-amazon-rds",
    "name": "Amazon Rds",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-rds.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-amazon-redshift': {
    "id": "aws-amazon-redshift",
    "name": "Amazon Redshift",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-redshift.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-rekognition': {
    "id": "aws-amazon-rekognition",
    "name": "Amazon Rekognition",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-rekognition.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-route-53': {
    "id": "aws-amazon-route-53",
    "name": "Amazon Route 53",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-route-53.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-s3-on-outposts': {
    "id": "aws-amazon-s3-on-outposts",
    "name": "Amazon S3 On Outposts",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-s3-on-outposts.svg",
    "format": "svg",
    "tags": [
      "aws",
      "storage"
    ]
  },
  'aws-amazon-sagemaker-ground-truth': {
    "id": "aws-amazon-sagemaker-ground-truth",
    "name": "Amazon Sagemaker Ground Truth",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-sagemaker-ground-truth.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-sagemaker-studio-lab': {
    "id": "aws-amazon-sagemaker-studio-lab",
    "name": "Amazon Sagemaker Studio Lab",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-sagemaker-studio-lab.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-sagemaker': {
    "id": "aws-amazon-sagemaker",
    "name": "Amazon Sagemaker",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-sagemaker.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-security-lake': {
    "id": "aws-amazon-security-lake",
    "name": "Amazon Security Lake",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-security-lake.svg",
    "format": "svg",
    "tags": [
      "aws",
      "security"
    ]
  },
  'aws-amazon-simple-email-service': {
    "id": "aws-amazon-simple-email-service",
    "name": "Amazon Simple Email Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-simple-email-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-simple-notification-service': {
    "id": "aws-amazon-simple-notification-service",
    "name": "Amazon Simple Notification Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-simple-notification-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-simple-queue-service': {
    "id": "aws-amazon-simple-queue-service",
    "name": "Amazon Simple Queue Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-simple-queue-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "queue",
      "messaging"
    ]
  },
  'aws-amazon-simple-storage-service-glacier': {
    "id": "aws-amazon-simple-storage-service-glacier",
    "name": "Amazon Simple Storage Service Glacier",
    "provider": "aws",
    "category": "storage",
    "path": "/icons/aws/amazon-simple-storage-service-glacier.svg",
    "format": "svg",
    "tags": [
      "aws",
      "storage"
    ]
  },
  'aws-amazon-simple-storage-service': {
    "id": "aws-amazon-simple-storage-service",
    "name": "Amazon Simple Storage Service",
    "provider": "aws",
    "category": "storage",
    "path": "/icons/aws/amazon-simple-storage-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "storage"
    ]
  },
  'aws-amazon-textract': {
    "id": "aws-amazon-textract",
    "name": "Amazon Textract",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-textract.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-timestream': {
    "id": "aws-amazon-timestream",
    "name": "Amazon Timestream",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-timestream.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-transcribe': {
    "id": "aws-amazon-transcribe",
    "name": "Amazon Transcribe",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-transcribe.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-translate': {
    "id": "aws-amazon-translate",
    "name": "Amazon Translate",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-translate.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-verified-permissions': {
    "id": "aws-amazon-verified-permissions",
    "name": "Amazon Verified Permissions",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-verified-permissions.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-virtual-private-cloud': {
    "id": "aws-amazon-virtual-private-cloud",
    "name": "Amazon Virtual Private Cloud",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-virtual-private-cloud.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-vpc-lattice': {
    "id": "aws-amazon-vpc-lattice",
    "name": "Amazon Vpc Lattice",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-vpc-lattice.svg",
    "format": "svg",
    "tags": [
      "aws",
      "networking"
    ]
  },
  'aws-amazon-workdocs-sdk': {
    "id": "aws-amazon-workdocs-sdk",
    "name": "Amazon Workdocs Sdk",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-workdocs-sdk.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-workdocs': {
    "id": "aws-amazon-workdocs",
    "name": "Amazon Workdocs",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-workdocs.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-worklink': {
    "id": "aws-amazon-worklink",
    "name": "Amazon Worklink",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-worklink.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-workmail': {
    "id": "aws-amazon-workmail",
    "name": "Amazon Workmail",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-workmail.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-amazon-workspaces-family': {
    "id": "aws-amazon-workspaces-family",
    "name": "Amazon Workspaces Family",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/amazon-workspaces-family.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-analytics': {
    "id": "aws-analytics",
    "name": "Analytics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/analytics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-apache-mxnet-on-aws': {
    "id": "aws-apache-mxnet-on-aws",
    "name": "Apache Mxnet On Aws",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/apache-mxnet-on-aws.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-application-integration': {
    "id": "aws-application-integration",
    "name": "Application Integration",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/application-integration.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-activate': {
    "id": "aws-aws-activate",
    "name": "Aws Activate",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-activate.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-amplify': {
    "id": "aws-aws-amplify",
    "name": "Aws Amplify",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-amplify.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-app-mesh': {
    "id": "aws-aws-app-mesh",
    "name": "Aws App Mesh",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-app-mesh.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-app-runner': {
    "id": "aws-aws-app-runner",
    "name": "Aws App Runner",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-app-runner.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-appconfig': {
    "id": "aws-aws-appconfig",
    "name": "Aws Appconfig",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-appconfig.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-application-auto-scaling': {
    "id": "aws-aws-application-auto-scaling",
    "name": "Aws Application Auto Scaling",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-application-auto-scaling.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-application-composer': {
    "id": "aws-aws-application-composer",
    "name": "Aws Application Composer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-application-composer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-application-cost-profiler': {
    "id": "aws-aws-application-cost-profiler",
    "name": "Aws Application Cost Profiler",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-application-cost-profiler.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-application-discovery-service': {
    "id": "aws-aws-application-discovery-service",
    "name": "Aws Application Discovery Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-application-discovery-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-application-migration-service': {
    "id": "aws-aws-application-migration-service",
    "name": "Aws Application Migration Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-application-migration-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-appsync': {
    "id": "aws-aws-appsync",
    "name": "Aws Appsync",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-appsync.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-artifact': {
    "id": "aws-aws-artifact",
    "name": "Aws Artifact",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-artifact.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-audit-manager': {
    "id": "aws-aws-audit-manager",
    "name": "Aws Audit Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-audit-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-auto-scaling': {
    "id": "aws-aws-auto-scaling",
    "name": "Aws Auto Scaling",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-auto-scaling.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-backint-agent': {
    "id": "aws-aws-backint-agent",
    "name": "Aws Backint Agent",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-backint-agent.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-backup': {
    "id": "aws-aws-backup",
    "name": "Aws Backup",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-backup.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-batch': {
    "id": "aws-aws-batch",
    "name": "Aws Batch",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-batch.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-billing-conductor': {
    "id": "aws-aws-billing-conductor",
    "name": "Aws Billing Conductor",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-billing-conductor.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-budgets': {
    "id": "aws-aws-budgets",
    "name": "Aws Budgets",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-budgets.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-certificate-manager': {
    "id": "aws-aws-certificate-manager",
    "name": "Aws Certificate Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-certificate-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-chatbot': {
    "id": "aws-aws-chatbot",
    "name": "Aws Chatbot",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-chatbot.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-clean-rooms': {
    "id": "aws-aws-clean-rooms",
    "name": "Aws Clean Rooms",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-clean-rooms.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-client-vpn': {
    "id": "aws-aws-client-vpn",
    "name": "Aws Client Vpn",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-client-vpn.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloud-control-api': {
    "id": "aws-aws-cloud-control-api",
    "name": "Aws Cloud Control Api",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloud-control-api.svg",
    "format": "svg",
    "tags": [
      "aws",
      "api"
    ]
  },
  'aws-aws-cloud-development-kit': {
    "id": "aws-aws-cloud-development-kit",
    "name": "Aws Cloud Development Kit",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloud-development-kit.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloud-map': {
    "id": "aws-aws-cloud-map",
    "name": "Aws Cloud Map",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloud-map.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloud-wan': {
    "id": "aws-aws-cloud-wan",
    "name": "Aws Cloud Wan",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloud-wan.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloud9': {
    "id": "aws-aws-cloud9",
    "name": "Aws Cloud9",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloud9.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloudformation': {
    "id": "aws-aws-cloudformation",
    "name": "Aws Cloudformation",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloudformation.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloudhsm': {
    "id": "aws-aws-cloudhsm",
    "name": "Aws Cloudhsm",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloudhsm.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloudshell': {
    "id": "aws-aws-cloudshell",
    "name": "Aws Cloudshell",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloudshell.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cloudtrail': {
    "id": "aws-aws-cloudtrail",
    "name": "Aws Cloudtrail",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cloudtrail.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codeartifact': {
    "id": "aws-aws-codeartifact",
    "name": "Aws Codeartifact",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codeartifact.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codebuild': {
    "id": "aws-aws-codebuild",
    "name": "Aws Codebuild",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codebuild.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codecommit': {
    "id": "aws-aws-codecommit",
    "name": "Aws Codecommit",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codecommit.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codedeploy': {
    "id": "aws-aws-codedeploy",
    "name": "Aws Codedeploy",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codedeploy.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codepipeline': {
    "id": "aws-aws-codepipeline",
    "name": "Aws Codepipeline",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codepipeline.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-codestar': {
    "id": "aws-aws-codestar",
    "name": "Aws Codestar",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-codestar.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-command-line-interface': {
    "id": "aws-aws-command-line-interface",
    "name": "Aws Command Line Interface",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-command-line-interface.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-compute-optimizer': {
    "id": "aws-aws-compute-optimizer",
    "name": "Aws Compute Optimizer",
    "provider": "aws",
    "category": "compute",
    "path": "/icons/aws/aws-compute-optimizer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },
  'aws-aws-config': {
    "id": "aws-aws-config",
    "name": "Aws Config",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-config.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-console-mobile-application': {
    "id": "aws-aws-console-mobile-application",
    "name": "Aws Console Mobile Application",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-console-mobile-application.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-control-tower': {
    "id": "aws-aws-control-tower",
    "name": "Aws Control Tower",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-control-tower.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cost-and-usage-report': {
    "id": "aws-aws-cost-and-usage-report",
    "name": "Aws Cost And Usage Report",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cost-and-usage-report.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-cost-explorer': {
    "id": "aws-aws-cost-explorer",
    "name": "Aws Cost Explorer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-cost-explorer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-data-exchange': {
    "id": "aws-aws-data-exchange",
    "name": "Aws Data Exchange",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-data-exchange.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-data-pipeline': {
    "id": "aws-aws-data-pipeline",
    "name": "Aws Data Pipeline",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-data-pipeline.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-database-migration-service': {
    "id": "aws-aws-database-migration-service",
    "name": "Aws Database Migration Service",
    "provider": "aws",
    "category": "database",
    "path": "/icons/aws/aws-database-migration-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-aws-datasync': {
    "id": "aws-aws-datasync",
    "name": "Aws Datasync",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-datasync.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-deep-learning-amis': {
    "id": "aws-aws-deep-learning-amis",
    "name": "Aws Deep Learning Amis",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-deep-learning-amis.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-deep-learning-containers': {
    "id": "aws-aws-deep-learning-containers",
    "name": "Aws Deep Learning Containers",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-deep-learning-containers.svg",
    "format": "svg",
    "tags": [
      "aws",
      "container"
    ]
  },
  'aws-aws-deepcomposer': {
    "id": "aws-aws-deepcomposer",
    "name": "Aws Deepcomposer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-deepcomposer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-deeplens': {
    "id": "aws-aws-deeplens",
    "name": "Aws Deeplens",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-deeplens.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-deepracer': {
    "id": "aws-aws-deepracer",
    "name": "Aws Deepracer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-deepracer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-device-farm': {
    "id": "aws-aws-device-farm",
    "name": "Aws Device Farm",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-device-farm.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-direct-connect': {
    "id": "aws-aws-direct-connect",
    "name": "Aws Direct Connect",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-direct-connect.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-directory-service': {
    "id": "aws-aws-directory-service",
    "name": "Aws Directory Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-directory-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-distro-for-opentelemetry': {
    "id": "aws-aws-distro-for-opentelemetry",
    "name": "Aws Distro For Opentelemetry",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-distro-for-opentelemetry.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elastic-beanstalk': {
    "id": "aws-aws-elastic-beanstalk",
    "name": "Aws Elastic Beanstalk",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elastic-beanstalk.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elastic-disaster-recovery': {
    "id": "aws-aws-elastic-disaster-recovery",
    "name": "Aws Elastic Disaster Recovery",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elastic-disaster-recovery.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-appliances-software': {
    "id": "aws-aws-elemental-appliances-software",
    "name": "Aws Elemental Appliances Software",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-appliances-software.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-conductor': {
    "id": "aws-aws-elemental-conductor",
    "name": "Aws Elemental Conductor",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-conductor.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-delta': {
    "id": "aws-aws-elemental-delta",
    "name": "Aws Elemental Delta",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-delta.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-link': {
    "id": "aws-aws-elemental-link",
    "name": "Aws Elemental Link",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-link.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-live': {
    "id": "aws-aws-elemental-live",
    "name": "Aws Elemental Live",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-live.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-mediaconnect': {
    "id": "aws-aws-elemental-mediaconnect",
    "name": "Aws Elemental Mediaconnect",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-mediaconnect.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-mediaconvert': {
    "id": "aws-aws-elemental-mediaconvert",
    "name": "Aws Elemental Mediaconvert",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-mediaconvert.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-medialive': {
    "id": "aws-aws-elemental-medialive",
    "name": "Aws Elemental Medialive",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-medialive.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-mediapackage': {
    "id": "aws-aws-elemental-mediapackage",
    "name": "Aws Elemental Mediapackage",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-mediapackage.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-mediastore': {
    "id": "aws-aws-elemental-mediastore",
    "name": "Aws Elemental Mediastore",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-mediastore.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-mediatailor': {
    "id": "aws-aws-elemental-mediatailor",
    "name": "Aws Elemental Mediatailor",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-mediatailor.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-elemental-server': {
    "id": "aws-aws-elemental-server",
    "name": "Aws Elemental Server",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-elemental-server.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-express-workflows': {
    "id": "aws-aws-express-workflows",
    "name": "Aws Express Workflows",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-express-workflows.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-fargate': {
    "id": "aws-aws-fargate",
    "name": "Aws Fargate",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-fargate.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-fault-injection-simulator': {
    "id": "aws-aws-fault-injection-simulator",
    "name": "Aws Fault Injection Simulator",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-fault-injection-simulator.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-firewall-manager': {
    "id": "aws-aws-firewall-manager",
    "name": "Aws Firewall Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-firewall-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-gamekit': {
    "id": "aws-aws-gamekit",
    "name": "Aws Gamekit",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-gamekit.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-global-accelerator': {
    "id": "aws-aws-global-accelerator",
    "name": "Aws Global Accelerator",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-global-accelerator.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-glue-databrew': {
    "id": "aws-aws-glue-databrew",
    "name": "Aws Glue Databrew",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-glue-databrew.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-glue-elastic-views': {
    "id": "aws-aws-glue-elastic-views",
    "name": "Aws Glue Elastic Views",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-glue-elastic-views.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-glue': {
    "id": "aws-aws-glue",
    "name": "Aws Glue",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-glue.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-ground-station': {
    "id": "aws-aws-ground-station",
    "name": "Aws Ground Station",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-ground-station.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-health-dashboard': {
    "id": "aws-aws-health-dashboard",
    "name": "Aws Health Dashboard",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-health-dashboard.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iam-identity-center': {
    "id": "aws-aws-iam-identity-center",
    "name": "Aws Iam Identity Center",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iam-identity-center.svg",
    "format": "svg",
    "tags": [
      "aws",
      "security"
    ]
  },
  'aws-aws-identity-and-access-management': {
    "id": "aws-aws-identity-and-access-management",
    "name": "Aws Identity And Access Management",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-identity-and-access-management.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-1-click': {
    "id": "aws-aws-iot-1-click",
    "name": "Aws Iot 1 Click",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-1-click.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-analytics': {
    "id": "aws-aws-iot-analytics",
    "name": "Aws Iot Analytics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-analytics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-button': {
    "id": "aws-aws-iot-button",
    "name": "Aws Iot Button",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-button.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-core': {
    "id": "aws-aws-iot-core",
    "name": "Aws Iot Core",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-core.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-device-defender': {
    "id": "aws-aws-iot-device-defender",
    "name": "Aws Iot Device Defender",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-device-defender.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-device-management': {
    "id": "aws-aws-iot-device-management",
    "name": "Aws Iot Device Management",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-device-management.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-edukit': {
    "id": "aws-aws-iot-edukit",
    "name": "Aws Iot Edukit",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-edukit.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-events': {
    "id": "aws-aws-iot-events",
    "name": "Aws Iot Events",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-events.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-expresslink': {
    "id": "aws-aws-iot-expresslink",
    "name": "Aws Iot Expresslink",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-expresslink.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-fleetwise': {
    "id": "aws-aws-iot-fleetwise",
    "name": "Aws Iot Fleetwise",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-fleetwise.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-greengrass': {
    "id": "aws-aws-iot-greengrass",
    "name": "Aws Iot Greengrass",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-greengrass.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-roborunner': {
    "id": "aws-aws-iot-roborunner",
    "name": "Aws Iot Roborunner",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-roborunner.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-sitewise': {
    "id": "aws-aws-iot-sitewise",
    "name": "Aws Iot Sitewise",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-sitewise.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-things-graph': {
    "id": "aws-aws-iot-things-graph",
    "name": "Aws Iot Things Graph",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-things-graph.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iot-twinmaker': {
    "id": "aws-aws-iot-twinmaker",
    "name": "Aws Iot Twinmaker",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iot-twinmaker.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-iq': {
    "id": "aws-aws-iq",
    "name": "Aws Iq",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-iq.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-key-management-service': {
    "id": "aws-aws-key-management-service",
    "name": "Aws Key Management Service",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-key-management-service.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-lake-formation': {
    "id": "aws-aws-lake-formation",
    "name": "Aws Lake Formation",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-lake-formation.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-lambda': {
    "id": "aws-aws-lambda",
    "name": "Aws Lambda",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-lambda.svg",
    "format": "svg",
    "tags": [
      "aws",
      "serverless",
      "function"
    ]
  },
  'aws-aws-launch-wizard': {
    "id": "aws-aws-launch-wizard",
    "name": "Aws Launch Wizard",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-launch-wizard.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-license-manager': {
    "id": "aws-aws-license-manager",
    "name": "Aws License Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-license-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-local-zones': {
    "id": "aws-aws-local-zones",
    "name": "Aws Local Zones",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-local-zones.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-mainframe-modernization': {
    "id": "aws-aws-mainframe-modernization",
    "name": "Aws Mainframe Modernization",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-mainframe-modernization.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-managed-services': {
    "id": "aws-aws-managed-services",
    "name": "Aws Managed Services",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-managed-services.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-management-console': {
    "id": "aws-aws-management-console",
    "name": "Aws Management Console",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-management-console.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-marketplace-dark': {
    "id": "aws-aws-marketplace-dark",
    "name": "Aws Marketplace Dark",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-marketplace-dark.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-marketplace-light': {
    "id": "aws-aws-marketplace-light",
    "name": "Aws Marketplace Light",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-marketplace-light.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-migration-evaluator': {
    "id": "aws-aws-migration-evaluator",
    "name": "Aws Migration Evaluator",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-migration-evaluator.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-migration-hub': {
    "id": "aws-aws-migration-hub",
    "name": "Aws Migration Hub",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-migration-hub.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-network-firewall': {
    "id": "aws-aws-network-firewall",
    "name": "Aws Network Firewall",
    "provider": "aws",
    "category": "networking",
    "path": "/icons/aws/aws-network-firewall.svg",
    "format": "svg",
    "tags": [
      "aws",
      "networking"
    ]
  },
  'aws-aws-neuron': {
    "id": "aws-aws-neuron",
    "name": "Aws Neuron",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-neuron.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-nitro-enclaves': {
    "id": "aws-aws-nitro-enclaves",
    "name": "Aws Nitro Enclaves",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-nitro-enclaves.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-opsworks': {
    "id": "aws-aws-opsworks",
    "name": "Aws Opsworks",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-opsworks.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-organizations': {
    "id": "aws-aws-organizations",
    "name": "Aws Organizations",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-organizations.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-outposts-family': {
    "id": "aws-aws-outposts-family",
    "name": "Aws Outposts Family",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-outposts-family.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-outposts-rack': {
    "id": "aws-aws-outposts-rack",
    "name": "Aws Outposts Rack",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-outposts-rack.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-outposts-servers': {
    "id": "aws-aws-outposts-servers",
    "name": "Aws Outposts Servers",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-outposts-servers.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-panorama': {
    "id": "aws-aws-panorama",
    "name": "Aws Panorama",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-panorama.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-parallel-cluster': {
    "id": "aws-aws-parallel-cluster",
    "name": "Aws Parallel Cluster",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-parallel-cluster.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-private-5g': {
    "id": "aws-aws-private-5g",
    "name": "Aws Private 5g",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-private-5g.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-private-certificate-authority': {
    "id": "aws-aws-private-certificate-authority",
    "name": "Aws Private Certificate Authority",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-private-certificate-authority.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-privatelink': {
    "id": "aws-aws-privatelink",
    "name": "Aws Privatelink",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-privatelink.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-professional-services': {
    "id": "aws-aws-professional-services",
    "name": "Aws Professional Services",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-professional-services.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-proton': {
    "id": "aws-aws-proton",
    "name": "Aws Proton",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-proton.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-re-post': {
    "id": "aws-aws-re-post",
    "name": "Aws Re Post",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-re-post.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-resilience-hub': {
    "id": "aws-aws-resilience-hub",
    "name": "Aws Resilience Hub",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-resilience-hub.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-resource-access-manager': {
    "id": "aws-aws-resource-access-manager",
    "name": "Aws Resource Access Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-resource-access-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-resource-explorer': {
    "id": "aws-aws-resource-explorer",
    "name": "Aws Resource Explorer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-resource-explorer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-robomaker': {
    "id": "aws-aws-robomaker",
    "name": "Aws Robomaker",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-robomaker.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-secrets-manager': {
    "id": "aws-aws-secrets-manager",
    "name": "Aws Secrets Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-secrets-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-security-hub': {
    "id": "aws-aws-security-hub",
    "name": "Aws Security Hub",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-security-hub.svg",
    "format": "svg",
    "tags": [
      "aws",
      "security"
    ]
  },
  'aws-aws-serverless-application-repository': {
    "id": "aws-aws-serverless-application-repository",
    "name": "Aws Serverless Application Repository",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-serverless-application-repository.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-service-catalog': {
    "id": "aws-aws-service-catalog",
    "name": "Aws Service Catalog",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-service-catalog.svg",
    "format": "svg",
    "tags": [
      "aws",
      "monitoring"
    ]
  },
  'aws-aws-service-management-connector': {
    "id": "aws-aws-service-management-connector",
    "name": "Aws Service Management Connector",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-service-management-connector.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-shield': {
    "id": "aws-aws-shield",
    "name": "Aws Shield",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-shield.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-signer': {
    "id": "aws-aws-signer",
    "name": "Aws Signer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-signer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-simspace-weaver': {
    "id": "aws-aws-simspace-weaver",
    "name": "Aws Simspace Weaver",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-simspace-weaver.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-site-to-site-vpn': {
    "id": "aws-aws-site-to-site-vpn",
    "name": "Aws Site To Site Vpn",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-site-to-site-vpn.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-snowball-edge': {
    "id": "aws-aws-snowball-edge",
    "name": "Aws Snowball Edge",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-snowball-edge.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-snowball': {
    "id": "aws-aws-snowball",
    "name": "Aws Snowball",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-snowball.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-snowcone': {
    "id": "aws-aws-snowcone",
    "name": "Aws Snowcone",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-snowcone.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-snowmobile': {
    "id": "aws-aws-snowmobile",
    "name": "Aws Snowmobile",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-snowmobile.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-step-functions': {
    "id": "aws-aws-step-functions",
    "name": "Aws Step Functions",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-step-functions.svg",
    "format": "svg",
    "tags": [
      "aws",
      "serverless",
      "function"
    ]
  },
  'aws-aws-storage-gateway': {
    "id": "aws-aws-storage-gateway",
    "name": "Aws Storage Gateway",
    "provider": "aws",
    "category": "storage",
    "path": "/icons/aws/aws-storage-gateway.svg",
    "format": "svg",
    "tags": [
      "aws",
      "storage",
      "api"
    ]
  },
  'aws-aws-supply-chain': {
    "id": "aws-aws-supply-chain",
    "name": "Aws Supply Chain",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-supply-chain.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-support': {
    "id": "aws-aws-support",
    "name": "Aws Support",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-support.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-systems-manager': {
    "id": "aws-aws-systems-manager",
    "name": "Aws Systems Manager",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-systems-manager.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-telco-network-builder': {
    "id": "aws-aws-telco-network-builder",
    "name": "Aws Telco Network Builder",
    "provider": "aws",
    "category": "networking",
    "path": "/icons/aws/aws-telco-network-builder.svg",
    "format": "svg",
    "tags": [
      "aws",
      "networking"
    ]
  },
  'aws-aws-thinkbox-deadline': {
    "id": "aws-aws-thinkbox-deadline",
    "name": "Aws Thinkbox Deadline",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-deadline.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-thinkbox-frost': {
    "id": "aws-aws-thinkbox-frost",
    "name": "Aws Thinkbox Frost",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-frost.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-thinkbox-krakatoa': {
    "id": "aws-aws-thinkbox-krakatoa",
    "name": "Aws Thinkbox Krakatoa",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-krakatoa.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-thinkbox-sequoia': {
    "id": "aws-aws-thinkbox-sequoia",
    "name": "Aws Thinkbox Sequoia",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-sequoia.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-thinkbox-stoke': {
    "id": "aws-aws-thinkbox-stoke",
    "name": "Aws Thinkbox Stoke",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-stoke.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-thinkbox-xmesh': {
    "id": "aws-aws-thinkbox-xmesh",
    "name": "Aws Thinkbox Xmesh",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-thinkbox-xmesh.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-tools-and-sdks': {
    "id": "aws-aws-tools-and-sdks",
    "name": "Aws Tools And Sdks",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-tools-and-sdks.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-training-certification': {
    "id": "aws-aws-training-certification",
    "name": "Aws Training Certification",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-training-certification.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-transfer-family': {
    "id": "aws-aws-transfer-family",
    "name": "Aws Transfer Family",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-transfer-family.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-transit-gateway': {
    "id": "aws-aws-transit-gateway",
    "name": "Aws Transit Gateway",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-transit-gateway.svg",
    "format": "svg",
    "tags": [
      "aws",
      "api"
    ]
  },
  'aws-aws-trusted-advisor': {
    "id": "aws-aws-trusted-advisor",
    "name": "Aws Trusted Advisor",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-trusted-advisor.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-verified-access': {
    "id": "aws-aws-verified-access",
    "name": "Aws Verified Access",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-verified-access.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-waf': {
    "id": "aws-aws-waf",
    "name": "Aws Waf",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-waf.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-wavelength': {
    "id": "aws-aws-wavelength",
    "name": "Aws Wavelength",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-wavelength.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-well-architected-tool': {
    "id": "aws-aws-well-architected-tool",
    "name": "Aws Well Architected Tool",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-well-architected-tool.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-wickr': {
    "id": "aws-aws-wickr",
    "name": "Aws Wickr",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-wickr.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-aws-x-ray': {
    "id": "aws-aws-x-ray",
    "name": "Aws X Ray",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/aws-x-ray.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-blockchain': {
    "id": "aws-blockchain",
    "name": "Blockchain",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/blockchain.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-bottlerocket': {
    "id": "aws-bottlerocket",
    "name": "Bottlerocket",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/bottlerocket.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-business-applications': {
    "id": "aws-business-applications",
    "name": "Business Applications",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/business-applications.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-cloud-financial-management': {
    "id": "aws-cloud-financial-management",
    "name": "Cloud Financial Management",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/cloud-financial-management.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-compute': {
    "id": "aws-compute",
    "name": "Compute",
    "provider": "aws",
    "category": "compute",
    "path": "/icons/aws/compute.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },
  'aws-contact-center': {
    "id": "aws-contact-center",
    "name": "Contact Center",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/contact-center.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-containers': {
    "id": "aws-containers",
    "name": "Containers",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/containers.svg",
    "format": "svg",
    "tags": [
      "aws",
      "container"
    ]
  },
  'aws-customer-enablement': {
    "id": "aws-customer-enablement",
    "name": "Customer Enablement",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/customer-enablement.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-database': {
    "id": "aws-database",
    "name": "Database",
    "provider": "aws",
    "category": "database",
    "path": "/icons/aws/database.svg",
    "format": "svg",
    "tags": [
      "aws",
      "database"
    ]
  },
  'aws-developer-tools': {
    "id": "aws-developer-tools",
    "name": "Developer Tools",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/developer-tools.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-elastic-fabric-adapter': {
    "id": "aws-elastic-fabric-adapter",
    "name": "Elastic Fabric Adapter",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/elastic-fabric-adapter.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-elastic-load-balancing': {
    "id": "aws-elastic-load-balancing",
    "name": "Elastic Load Balancing",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/elastic-load-balancing.svg",
    "format": "svg",
    "tags": [
      "aws",
      "load-balancer"
    ]
  },
  'aws-end-user-computing': {
    "id": "aws-end-user-computing",
    "name": "End User Computing",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/end-user-computing.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-freertos': {
    "id": "aws-freertos",
    "name": "Freertos",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/freertos.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-front-end-web-mobile': {
    "id": "aws-front-end-web-mobile",
    "name": "Front End Web Mobile",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/front-end-web-mobile.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-games': {
    "id": "aws-games",
    "name": "Games",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/games.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-internet-of-things': {
    "id": "aws-internet-of-things",
    "name": "Internet Of Things",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/internet-of-things.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-machine-learning': {
    "id": "aws-machine-learning",
    "name": "Machine Learning",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/machine-learning.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-management-governance': {
    "id": "aws-management-governance",
    "name": "Management Governance",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/management-governance.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-media-services': {
    "id": "aws-media-services",
    "name": "Media Services",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/media-services.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-migration-transfer': {
    "id": "aws-migration-transfer",
    "name": "Migration Transfer",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/migration-transfer.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-networking-content-delivery': {
    "id": "aws-networking-content-delivery",
    "name": "Networking Content Delivery",
    "provider": "aws",
    "category": "networking",
    "path": "/icons/aws/networking-content-delivery.svg",
    "format": "svg",
    "tags": [
      "aws",
      "networking"
    ]
  },
  'aws-nice-dcv': {
    "id": "aws-nice-dcv",
    "name": "Nice Dcv",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/nice-dcv.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-nice-enginframe': {
    "id": "aws-nice-enginframe",
    "name": "Nice Enginframe",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/nice-enginframe.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-open-3d-engine': {
    "id": "aws-open-3d-engine",
    "name": "Open 3d Engine",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/open-3d-engine.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-quantum-technologies': {
    "id": "aws-quantum-technologies",
    "name": "Quantum Technologies",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/quantum-technologies.svg",
    "format": "svg",
    "tags": [
      "aws",
      "monitoring"
    ]
  },
  'aws-red-hat-openshift-service-on-aws': {
    "id": "aws-red-hat-openshift-service-on-aws",
    "name": "Red Hat Openshift Service On Aws",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/red-hat-openshift-service-on-aws.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-reserved-instance-reporting': {
    "id": "aws-reserved-instance-reporting",
    "name": "Reserved Instance Reporting",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/reserved-instance-reporting.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-robotics': {
    "id": "aws-robotics",
    "name": "Robotics",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/robotics.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-satellite': {
    "id": "aws-satellite",
    "name": "Satellite",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/satellite.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-savings-plans': {
    "id": "aws-savings-plans",
    "name": "Savings Plans",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/savings-plans.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-security-identity-compliance': {
    "id": "aws-security-identity-compliance",
    "name": "Security Identity Compliance",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/security-identity-compliance.svg",
    "format": "svg",
    "tags": [
      "aws",
      "security"
    ]
  },
  'aws-serverless': {
    "id": "aws-serverless",
    "name": "Serverless",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/serverless.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-storage': {
    "id": "aws-storage",
    "name": "Storage",
    "provider": "aws",
    "category": "storage",
    "path": "/icons/aws/storage.svg",
    "format": "svg",
    "tags": [
      "aws",
      "storage"
    ]
  },
  'aws-tensorflow-on-aws': {
    "id": "aws-tensorflow-on-aws",
    "name": "Tensorflow On Aws",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/tensorflow-on-aws.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-torchserve': {
    "id": "aws-torchserve",
    "name": "Torchserve",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/torchserve.svg",
    "format": "svg",
    "tags": [
      "aws",
      "service"
    ]
  },
  'aws-vmware-cloud-on-aws': {
    "id": "aws-vmware-cloud-on-aws",
    "name": "Vmware Cloud On Aws",
    "provider": "aws",
    "category": "service",
    "path": "/icons/aws/vmware-cloud-on-aws.svg",
    "format": "svg",
    "tags": [
      "aws",
      "compute",
      "server"
    ]
  },

  // Azure (619 icons)
  'azure-aad-licenses-2': {
    "id": "azure-aad-licenses-2",
    "name": "Aad Licenses 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/aad-licenses-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-aad-licenses': {
    "id": "azure-aad-licenses",
    "name": "Aad Licenses",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/aad-licenses.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-abs-member': {
    "id": "azure-abs-member",
    "name": "Abs Member",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/abs-member.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-active-directory-connect-health': {
    "id": "azure-active-directory-connect-health",
    "name": "Active Directory Connect Health",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/active-directory-connect-health.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-activity-log-2': {
    "id": "azure-activity-log-2",
    "name": "Activity Log 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/activity-log-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  // ... 614 more azure icons
  'azure-activity-log': {
    "id": "azure-activity-log",
    "name": "Activity Log",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/activity-log.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-administrative-units': {
    "id": "azure-administrative-units",
    "name": "Administrative Units",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/administrative-units.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-advisor': {
    "id": "azure-advisor",
    "name": "Advisor",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/advisor.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-alerts': {
    "id": "azure-alerts",
    "name": "Alerts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/alerts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-all-resources': {
    "id": "azure-all-resources",
    "name": "All Resources",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/all-resources.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-analysis-services': {
    "id": "azure-analysis-services",
    "name": "Analysis Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/analysis-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-anomaly-detector': {
    "id": "azure-anomaly-detector",
    "name": "Anomaly Detector",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/anomaly-detector.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-api-connections-2': {
    "id": "azure-api-connections-2",
    "name": "Api Connections 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-connections-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-connections-3': {
    "id": "azure-api-connections-3",
    "name": "Api Connections 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-connections-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-connections': {
    "id": "azure-api-connections",
    "name": "Api Connections",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-connections.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-management-services-2': {
    "id": "azure-api-management-services-2",
    "name": "Api Management Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-management-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-management-services-3': {
    "id": "azure-api-management-services-3",
    "name": "Api Management Services 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-management-services-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-management-services': {
    "id": "azure-api-management-services",
    "name": "Api Management Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-management-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-api-proxy': {
    "id": "azure-api-proxy",
    "name": "Api Proxy",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/api-proxy.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-app-compliance-automation': {
    "id": "azure-app-compliance-automation",
    "name": "App Compliance Automation",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-compliance-automation.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-configuration': {
    "id": "azure-app-configuration",
    "name": "App Configuration",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-configuration.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-registrations-2': {
    "id": "azure-app-registrations-2",
    "name": "App Registrations 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-registrations-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-registrations': {
    "id": "azure-app-registrations",
    "name": "App Registrations",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-registrations.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-certificates-2': {
    "id": "azure-app-service-certificates-2",
    "name": "App Service Certificates 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-certificates-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-certificates': {
    "id": "azure-app-service-certificates",
    "name": "App Service Certificates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-certificates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-domains-2': {
    "id": "azure-app-service-domains-2",
    "name": "App Service Domains 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-domains-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-domains': {
    "id": "azure-app-service-domains",
    "name": "App Service Domains",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-domains.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-environments-2': {
    "id": "azure-app-service-environments-2",
    "name": "App Service Environments 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-environments-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-environments': {
    "id": "azure-app-service-environments",
    "name": "App Service Environments",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-environments.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-plans-2': {
    "id": "azure-app-service-plans-2",
    "name": "App Service Plans 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-plans-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-service-plans': {
    "id": "azure-app-service-plans",
    "name": "App Service Plans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-service-plans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-services-2': {
    "id": "azure-app-services-2",
    "name": "App Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-services-3': {
    "id": "azure-app-services-3",
    "name": "App Services 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-services-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-services-4': {
    "id": "azure-app-services-4",
    "name": "App Services 4",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-services-4.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-services-5': {
    "id": "azure-app-services-5",
    "name": "App Services 5",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-services-5.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-app-services': {
    "id": "azure-app-services",
    "name": "App Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/app-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-applens': {
    "id": "azure-applens",
    "name": "Applens",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/applens.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-application-gateways': {
    "id": "azure-application-gateways",
    "name": "Application Gateways",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-gateways.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-application-group': {
    "id": "azure-application-group",
    "name": "Application Group",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-group.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-application-insights-2': {
    "id": "azure-application-insights-2",
    "name": "Application Insights 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-insights-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-application-insights-3': {
    "id": "azure-application-insights-3",
    "name": "Application Insights 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-insights-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-application-insights': {
    "id": "azure-application-insights",
    "name": "Application Insights",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-insights.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-application-security-groups': {
    "id": "azure-application-security-groups",
    "name": "Application Security Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/application-security-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-aquila': {
    "id": "azure-aquila",
    "name": "Aquila",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/aquila.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-arc-data-services': {
    "id": "azure-arc-data-services",
    "name": "Arc Data Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-data-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-arc-kubernetes': {
    "id": "azure-arc-kubernetes",
    "name": "Arc Kubernetes",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-kubernetes.svg",
    "format": "svg",
    "tags": [
      "azure",
      "kubernetes"
    ]
  },
  'azure-arc-machines': {
    "id": "azure-arc-machines",
    "name": "Arc Machines",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-machines.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-arc-postgresql': {
    "id": "azure-arc-postgresql",
    "name": "Arc Postgresql",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-postgresql.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-arc-sql-managed-instance': {
    "id": "azure-arc-sql-managed-instance",
    "name": "Arc Sql Managed Instance",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-sql-managed-instance.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-arc-sql-server': {
    "id": "azure-arc-sql-server",
    "name": "Arc Sql Server",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/arc-sql-server.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-auto-scale': {
    "id": "azure-auto-scale",
    "name": "Auto Scale",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/auto-scale.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-automanaged-vm': {
    "id": "azure-automanaged-vm",
    "name": "Automanaged Vm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/automanaged-vm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-automation-accounts': {
    "id": "azure-automation-accounts",
    "name": "Automation Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/automation-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-availability-sets': {
    "id": "azure-availability-sets",
    "name": "Availability Sets",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/availability-sets.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-avs-vm': {
    "id": "azure-avs-vm",
    "name": "Avs Vm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/avs-vm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-azure-a': {
    "id": "azure-azure-a",
    "name": "Azure A",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-a.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-active-directory': {
    "id": "azure-azure-active-directory",
    "name": "Azure Active Directory",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-active-directory.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-authentication-methods': {
    "id": "azure-azure-ad-authentication-methods",
    "name": "Azure Ad Authentication Methods",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-authentication-methods.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-b2c': {
    "id": "azure-azure-ad-b2c",
    "name": "Azure Ad B2c",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-b2c.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-domain-services': {
    "id": "azure-azure-ad-domain-services",
    "name": "Azure Ad Domain Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-domain-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-identity-protection-2': {
    "id": "azure-azure-ad-identity-protection-2",
    "name": "Azure Ad Identity Protection 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-identity-protection-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-identity-protection': {
    "id": "azure-azure-ad-identity-protection",
    "name": "Azure Ad Identity Protection",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-identity-protection.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-privilege-identity-management': {
    "id": "azure-azure-ad-privilege-identity-management",
    "name": "Azure Ad Privilege Identity Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-privilege-identity-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-privleged-identity-management-2': {
    "id": "azure-azure-ad-privleged-identity-management-2",
    "name": "Azure Ad Privleged Identity Management 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-privleged-identity-management-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-privleged-identity-management': {
    "id": "azure-azure-ad-privleged-identity-management",
    "name": "Azure Ad Privleged Identity Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-privleged-identity-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-risky-signins': {
    "id": "azure-azure-ad-risky-signins",
    "name": "Azure Ad Risky Signins",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-risky-signins.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-risky-users': {
    "id": "azure-azure-ad-risky-users",
    "name": "Azure Ad Risky Users",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-risky-users.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-roles-and-administrators-2': {
    "id": "azure-azure-ad-roles-and-administrators-2",
    "name": "Azure Ad Roles And Administrators 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-roles-and-administrators-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-ad-roles-and-administrators': {
    "id": "azure-azure-ad-roles-and-administrators",
    "name": "Azure Ad Roles And Administrators",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-ad-roles-and-administrators.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-api-for-fhir': {
    "id": "azure-azure-api-for-fhir",
    "name": "Azure Api For Fhir",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-api-for-fhir.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-azure-applied-ai-services': {
    "id": "azure-azure-applied-ai-services",
    "name": "Azure Applied Ai Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-applied-ai-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-arc': {
    "id": "azure-azure-arc",
    "name": "Azure Arc",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-arc.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-backup-center': {
    "id": "azure-azure-backup-center",
    "name": "Azure Backup Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-backup-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-blockchain-service': {
    "id": "azure-azure-blockchain-service",
    "name": "Azure Blockchain Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-blockchain-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-center-for-sap': {
    "id": "azure-azure-center-for-sap",
    "name": "Azure Center For Sap",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-center-for-sap.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-chaos-studio': {
    "id": "azure-azure-chaos-studio",
    "name": "Azure Chaos Studio",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-chaos-studio.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-cloud-shell': {
    "id": "azure-azure-cloud-shell",
    "name": "Azure Cloud Shell",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-cloud-shell.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-communication-services': {
    "id": "azure-azure-communication-services",
    "name": "Azure Communication Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-communication-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-compute-galleries-2': {
    "id": "azure-azure-compute-galleries-2",
    "name": "Azure Compute Galleries 2",
    "provider": "azure",
    "category": "compute",
    "path": "/icons/azure/azure-compute-galleries-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-azure-compute-galleries': {
    "id": "azure-azure-compute-galleries",
    "name": "Azure Compute Galleries",
    "provider": "azure",
    "category": "compute",
    "path": "/icons/azure/azure-compute-galleries.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-azure-cosmos-db-2': {
    "id": "azure-azure-cosmos-db-2",
    "name": "Azure Cosmos Db 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-cosmos-db-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-cosmos-db': {
    "id": "azure-azure-cosmos-db",
    "name": "Azure Cosmos Db",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-cosmos-db.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-data-catalog': {
    "id": "azure-azure-data-catalog",
    "name": "Azure Data Catalog",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-data-catalog.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-azure-data-explorer-clusters-2': {
    "id": "azure-azure-data-explorer-clusters-2",
    "name": "Azure Data Explorer Clusters 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-data-explorer-clusters-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-data-explorer-clusters': {
    "id": "azure-azure-data-explorer-clusters",
    "name": "Azure Data Explorer Clusters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-data-explorer-clusters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-database-mariadb-server': {
    "id": "azure-azure-database-mariadb-server",
    "name": "Azure Database Mariadb Server",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-mariadb-server.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-database-migration-services-2': {
    "id": "azure-azure-database-migration-services-2",
    "name": "Azure Database Migration Services 2",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-migration-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-database-migration-services': {
    "id": "azure-azure-database-migration-services",
    "name": "Azure Database Migration Services",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-migration-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-database-mysql-server': {
    "id": "azure-azure-database-mysql-server",
    "name": "Azure Database Mysql Server",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-mysql-server.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-database-postgresql-server-group': {
    "id": "azure-azure-database-postgresql-server-group",
    "name": "Azure Database Postgresql Server Group",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-postgresql-server-group.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-database-postgresql-server': {
    "id": "azure-azure-database-postgresql-server",
    "name": "Azure Database Postgresql Server",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-database-postgresql-server.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-databox-gateway-2': {
    "id": "azure-azure-databox-gateway-2",
    "name": "Azure Databox Gateway 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-databox-gateway-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-azure-databox-gateway-3': {
    "id": "azure-azure-databox-gateway-3",
    "name": "Azure Databox Gateway 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-databox-gateway-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-azure-databox-gateway-4': {
    "id": "azure-azure-databox-gateway-4",
    "name": "Azure Databox Gateway 4",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-databox-gateway-4.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-azure-databox-gateway': {
    "id": "azure-azure-databox-gateway",
    "name": "Azure Databox Gateway",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-databox-gateway.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-azure-databricks': {
    "id": "azure-azure-databricks",
    "name": "Azure Databricks",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-databricks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-deployment-environments': {
    "id": "azure-azure-deployment-environments",
    "name": "Azure Deployment Environments",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-deployment-environments.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-devops': {
    "id": "azure-azure-devops",
    "name": "Azure Devops",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-devops.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-edge-hardware-center': {
    "id": "azure-azure-edge-hardware-center",
    "name": "Azure Edge Hardware Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-edge-hardware-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-experimentation-studio': {
    "id": "azure-azure-experimentation-studio",
    "name": "Azure Experimentation Studio",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-experimentation-studio.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-fileshares': {
    "id": "azure-azure-fileshares",
    "name": "Azure Fileshares",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-fileshares.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-firewall-manager': {
    "id": "azure-azure-firewall-manager",
    "name": "Azure Firewall Manager",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-firewall-manager.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-firewall-policy': {
    "id": "azure-azure-firewall-policy",
    "name": "Azure Firewall Policy",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-firewall-policy.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-hcp-cache': {
    "id": "azure-azure-hcp-cache",
    "name": "Azure Hcp Cache",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-hcp-cache.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-hpc-workbenches': {
    "id": "azure-azure-hpc-workbenches",
    "name": "Azure Hpc Workbenches",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-hpc-workbenches.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-hybrid-center': {
    "id": "azure-azure-hybrid-center",
    "name": "Azure Hybrid Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-hybrid-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-information-protection-2': {
    "id": "azure-azure-information-protection-2",
    "name": "Azure Information Protection 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-information-protection-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-information-protection': {
    "id": "azure-azure-information-protection",
    "name": "Azure Information Protection",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-information-protection.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-lighthouse': {
    "id": "azure-azure-lighthouse",
    "name": "Azure Lighthouse",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-lighthouse.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-load-testing': {
    "id": "azure-azure-load-testing",
    "name": "Azure Load Testing",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-load-testing.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-azure-managed-grafana': {
    "id": "azure-azure-managed-grafana",
    "name": "Azure Managed Grafana",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-managed-grafana.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-maps-accounts': {
    "id": "azure-azure-maps-accounts",
    "name": "Azure Maps Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-maps-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-media-service': {
    "id": "azure-azure-media-service",
    "name": "Azure Media Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-media-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-migrate': {
    "id": "azure-azure-migrate",
    "name": "Azure Migrate",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-migrate.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-monitor-dashboard': {
    "id": "azure-azure-monitor-dashboard",
    "name": "Azure Monitor Dashboard",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-monitor-dashboard.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-azure-monitors-for-sap-solutions': {
    "id": "azure-azure-monitors-for-sap-solutions",
    "name": "Azure Monitors For Sap Solutions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-monitors-for-sap-solutions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-azure-netapp-files': {
    "id": "azure-azure-netapp-files",
    "name": "Azure Netapp Files",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-netapp-files.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-network-function-manager-functions': {
    "id": "azure-azure-network-function-manager-functions",
    "name": "Azure Network Function Manager Functions",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/azure-network-function-manager-functions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "serverless",
      "function",
      "networking"
    ]
  },
  'azure-azure-network-function-manager': {
    "id": "azure-azure-network-function-manager",
    "name": "Azure Network Function Manager",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/azure-network-function-manager.svg",
    "format": "svg",
    "tags": [
      "azure",
      "serverless",
      "function",
      "networking"
    ]
  },
  'azure-azure-object-understanding': {
    "id": "azure-azure-object-understanding",
    "name": "Azure Object Understanding",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-object-understanding.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-orbital': {
    "id": "azure-azure-orbital",
    "name": "Azure Orbital",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-orbital.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-purview-accounts': {
    "id": "azure-azure-purview-accounts",
    "name": "Azure Purview Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-purview-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-quotas': {
    "id": "azure-azure-quotas",
    "name": "Azure Quotas",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-quotas.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-red-hat-openshift': {
    "id": "azure-azure-red-hat-openshift",
    "name": "Azure Red Hat Openshift",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-red-hat-openshift.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-sentinel': {
    "id": "azure-azure-sentinel",
    "name": "Azure Sentinel",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-sentinel.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-service-bus': {
    "id": "azure-azure-service-bus",
    "name": "Azure Service Bus",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-service-bus.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-sphere': {
    "id": "azure-azure-sphere",
    "name": "Azure Sphere",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-sphere.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-spring-apps-2': {
    "id": "azure-azure-spring-apps-2",
    "name": "Azure Spring Apps 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-spring-apps-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-spring-apps': {
    "id": "azure-azure-spring-apps",
    "name": "Azure Spring Apps",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-spring-apps.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-sql-edge': {
    "id": "azure-azure-sql-edge",
    "name": "Azure Sql Edge",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-sql-edge.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-sql-server-stretch-databases-2': {
    "id": "azure-azure-sql-server-stretch-databases-2",
    "name": "Azure Sql Server Stretch Databases 2",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-sql-server-stretch-databases-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-sql-server-stretch-databases': {
    "id": "azure-azure-sql-server-stretch-databases",
    "name": "Azure Sql Server Stretch Databases",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/azure-sql-server-stretch-databases.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-azure-sql-vm': {
    "id": "azure-azure-sql-vm",
    "name": "Azure Sql Vm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-sql-vm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-azure-sql': {
    "id": "azure-azure-sql",
    "name": "Azure Sql",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-sql.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-stack-edge-2': {
    "id": "azure-azure-stack-edge-2",
    "name": "Azure Stack Edge 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-stack-edge-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-stack-edge-3': {
    "id": "azure-azure-stack-edge-3",
    "name": "Azure Stack Edge 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-stack-edge-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-stack-edge': {
    "id": "azure-azure-stack-edge",
    "name": "Azure Stack Edge",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-stack-edge.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-stack': {
    "id": "azure-azure-stack",
    "name": "Azure Stack",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-stack.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-storage-mover': {
    "id": "azure-azure-storage-mover",
    "name": "Azure Storage Mover",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/azure-storage-mover.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-azure-support-center-blue': {
    "id": "azure-azure-support-center-blue",
    "name": "Azure Support Center Blue",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-support-center-blue.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-synapse-analytics-2': {
    "id": "azure-azure-synapse-analytics-2",
    "name": "Azure Synapse Analytics 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-synapse-analytics-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-synapse-analytics': {
    "id": "azure-azure-synapse-analytics",
    "name": "Azure Synapse Analytics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-synapse-analytics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-token-service': {
    "id": "azure-azure-token-service",
    "name": "Azure Token Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-token-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-video-indexer': {
    "id": "azure-azure-video-indexer",
    "name": "Azure Video Indexer",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-video-indexer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-virtual-desktop': {
    "id": "azure-azure-virtual-desktop",
    "name": "Azure Virtual Desktop",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-virtual-desktop.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-vmware-solution': {
    "id": "azure-azure-vmware-solution",
    "name": "Azure Vmware Solution",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-vmware-solution.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-azure-workbooks-2': {
    "id": "azure-azure-workbooks-2",
    "name": "Azure Workbooks 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-workbooks-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azure-workbooks': {
    "id": "azure-azure-workbooks",
    "name": "Azure Workbooks",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azure-workbooks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azureattestation': {
    "id": "azure-azureattestation",
    "name": "Azureattestation",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azureattestation.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-azurite': {
    "id": "azure-azurite",
    "name": "Azurite",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/azurite.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-backlog': {
    "id": "azure-backlog",
    "name": "Backlog",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/backlog.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-backup-vault': {
    "id": "azure-backup-vault",
    "name": "Backup Vault",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/backup-vault.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-bare-metal-infrastructure': {
    "id": "azure-bare-metal-infrastructure",
    "name": "Bare Metal Infrastructure",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/bare-metal-infrastructure.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-bastions': {
    "id": "azure-bastions",
    "name": "Bastions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/bastions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-batch-accounts-2': {
    "id": "azure-batch-accounts-2",
    "name": "Batch Accounts 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/batch-accounts-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-batch-accounts': {
    "id": "azure-batch-accounts",
    "name": "Batch Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/batch-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-batch-ai': {
    "id": "azure-batch-ai",
    "name": "Batch Ai",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/batch-ai.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-biz-talk': {
    "id": "azure-biz-talk",
    "name": "Biz Talk",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/biz-talk.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-blob-block': {
    "id": "azure-blob-block",
    "name": "Blob Block",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/blob-block.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-blob-page': {
    "id": "azure-blob-page",
    "name": "Blob Page",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/blob-page.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-blockchain-applications': {
    "id": "azure-blockchain-applications",
    "name": "Blockchain Applications",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/blockchain-applications.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-blueprints': {
    "id": "azure-blueprints",
    "name": "Blueprints",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/blueprints.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-bonsai': {
    "id": "azure-bonsai",
    "name": "Bonsai",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/bonsai.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-bot-services': {
    "id": "azure-bot-services",
    "name": "Bot Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/bot-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-branch': {
    "id": "azure-branch",
    "name": "Branch",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/branch.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-browser': {
    "id": "azure-browser",
    "name": "Browser",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/browser.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-bug': {
    "id": "azure-bug",
    "name": "Bug",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/bug.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-builds': {
    "id": "azure-builds",
    "name": "Builds",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/builds.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cache-redis': {
    "id": "azure-cache-redis",
    "name": "Cache Redis",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cache-redis.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cache': {
    "id": "azure-cache",
    "name": "Cache",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cache.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-capacity-reservation-groups': {
    "id": "azure-capacity-reservation-groups",
    "name": "Capacity Reservation Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/capacity-reservation-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-capacity': {
    "id": "azure-capacity",
    "name": "Capacity",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/capacity.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cdn-profiles-2': {
    "id": "azure-cdn-profiles-2",
    "name": "Cdn Profiles 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cdn-profiles-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-cdn-profiles': {
    "id": "azure-cdn-profiles",
    "name": "Cdn Profiles",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cdn-profiles.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-central-service-instance-for-sap': {
    "id": "azure-central-service-instance-for-sap",
    "name": "Central Service Instance For Sap",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/central-service-instance-for-sap.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-ceres': {
    "id": "azure-ceres",
    "name": "Ceres",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ceres.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-change-analysis-2': {
    "id": "azure-change-analysis-2",
    "name": "Change Analysis 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/change-analysis-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-change-analysis': {
    "id": "azure-change-analysis",
    "name": "Change Analysis",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/change-analysis.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-client-apps': {
    "id": "azure-client-apps",
    "name": "Client Apps",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/client-apps.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cloud-services-classic': {
    "id": "azure-cloud-services-classic",
    "name": "Cloud Services Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cloud-services-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cloud-services-extended-support': {
    "id": "azure-cloud-services-extended-support",
    "name": "Cloud Services Extended Support",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cloud-services-extended-support.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cloudtest': {
    "id": "azure-cloudtest",
    "name": "Cloudtest",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cloudtest.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-code': {
    "id": "azure-code",
    "name": "Code",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/code.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cognitive-search-2': {
    "id": "azure-cognitive-search-2",
    "name": "Cognitive Search 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cognitive-search-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cognitive-search-3': {
    "id": "azure-cognitive-search-3",
    "name": "Cognitive Search 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cognitive-search-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cognitive-search': {
    "id": "azure-cognitive-search",
    "name": "Cognitive Search",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cognitive-search.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cognitive-services-2': {
    "id": "azure-cognitive-services-2",
    "name": "Cognitive Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cognitive-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cognitive-services': {
    "id": "azure-cognitive-services",
    "name": "Cognitive Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cognitive-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-collaborative-service': {
    "id": "azure-collaborative-service",
    "name": "Collaborative Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/collaborative-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-commit': {
    "id": "azure-commit",
    "name": "Commit",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/commit.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-community-images': {
    "id": "azure-community-images",
    "name": "Community Images",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/community-images.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-compliance-center': {
    "id": "azure-compliance-center",
    "name": "Compliance Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/compliance-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-compliance': {
    "id": "azure-compliance",
    "name": "Compliance",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/compliance.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-computer-vision': {
    "id": "azure-computer-vision",
    "name": "Computer Vision",
    "provider": "azure",
    "category": "compute",
    "path": "/icons/azure/computer-vision.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-conditional-access': {
    "id": "azure-conditional-access",
    "name": "Conditional Access",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/conditional-access.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-confidential-ledgers': {
    "id": "azure-confidential-ledgers",
    "name": "Confidential Ledgers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/confidential-ledgers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-connected-cache': {
    "id": "azure-connected-cache",
    "name": "Connected Cache",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/connected-cache.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-connected-vehicle-platform': {
    "id": "azure-connected-vehicle-platform",
    "name": "Connected Vehicle Platform",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/connected-vehicle-platform.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-connections': {
    "id": "azure-connections",
    "name": "Connections",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/connections.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-consortium': {
    "id": "azure-consortium",
    "name": "Consortium",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/consortium.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-container-apps-environments': {
    "id": "azure-container-apps-environments",
    "name": "Container Apps Environments",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/container-apps-environments.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-container-instances-2': {
    "id": "azure-container-instances-2",
    "name": "Container Instances 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/container-instances-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-container-instances': {
    "id": "azure-container-instances",
    "name": "Container Instances",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/container-instances.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-container-registries': {
    "id": "azure-container-registries",
    "name": "Container Registries",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/container-registries.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-container-services-deprecated': {
    "id": "azure-container-services-deprecated",
    "name": "Container Services Deprecated",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/container-services-deprecated.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-content-moderators': {
    "id": "azure-content-moderators",
    "name": "Content Moderators",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/content-moderators.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-controls-horizontal': {
    "id": "azure-controls-horizontal",
    "name": "Controls Horizontal",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/controls-horizontal.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-controls': {
    "id": "azure-controls",
    "name": "Controls",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/controls.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-alerts': {
    "id": "azure-cost-alerts",
    "name": "Cost Alerts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-alerts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-analysis': {
    "id": "azure-cost-analysis",
    "name": "Cost Analysis",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-analysis.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-budgets': {
    "id": "azure-cost-budgets",
    "name": "Cost Budgets",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-budgets.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-export': {
    "id": "azure-cost-export",
    "name": "Cost Export",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-export.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-management-and-billing-2': {
    "id": "azure-cost-management-and-billing-2",
    "name": "Cost Management And Billing 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-management-and-billing-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-management-and-billing-3': {
    "id": "azure-cost-management-and-billing-3",
    "name": "Cost Management And Billing 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-management-and-billing-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-management-and-billing': {
    "id": "azure-cost-management-and-billing",
    "name": "Cost Management And Billing",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-management-and-billing.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cost-management': {
    "id": "azure-cost-management",
    "name": "Cost Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cost-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-counter': {
    "id": "azure-counter",
    "name": "Counter",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/counter.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-cubes': {
    "id": "azure-cubes",
    "name": "Cubes",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/cubes.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-custom-azure-ad-roles': {
    "id": "azure-custom-azure-ad-roles",
    "name": "Custom Azure Ad Roles",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/custom-azure-ad-roles.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-custom-ip-prefix': {
    "id": "azure-custom-ip-prefix",
    "name": "Custom Ip Prefix",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/custom-ip-prefix.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-custom-vision': {
    "id": "azure-custom-vision",
    "name": "Custom Vision",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/custom-vision.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-customer-lockbox-for-microsoft-azure': {
    "id": "azure-customer-lockbox-for-microsoft-azure",
    "name": "Customer Lockbox For Microsoft Azure",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/customer-lockbox-for-microsoft-azure.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dashboard-hub': {
    "id": "azure-dashboard-hub",
    "name": "Dashboard Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dashboard-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dashboard': {
    "id": "azure-dashboard",
    "name": "Dashboard",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dashboard.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-box-2': {
    "id": "azure-data-box-2",
    "name": "Data Box 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-box-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-box': {
    "id": "azure-data-box",
    "name": "Data Box",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-box.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-collection-rules': {
    "id": "azure-data-collection-rules",
    "name": "Data Collection Rules",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-collection-rules.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-factories-2': {
    "id": "azure-data-factories-2",
    "name": "Data Factories 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-factories-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-factories-3': {
    "id": "azure-data-factories-3",
    "name": "Data Factories 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-factories-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-factories': {
    "id": "azure-data-factories",
    "name": "Data Factories",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-factories.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-lake-analytics': {
    "id": "azure-data-lake-analytics",
    "name": "Data Lake Analytics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-lake-analytics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-lake-storage-gen1': {
    "id": "azure-data-lake-storage-gen1",
    "name": "Data Lake Storage Gen1",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/data-lake-storage-gen1.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-data-lake-store-gen1': {
    "id": "azure-data-lake-store-gen1",
    "name": "Data Lake Store Gen1",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-lake-store-gen1.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-share-invitations': {
    "id": "azure-data-share-invitations",
    "name": "Data Share Invitations",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-share-invitations.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-data-shares': {
    "id": "azure-data-shares",
    "name": "Data Shares",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/data-shares.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-database-instance-for-sap': {
    "id": "azure-database-instance-for-sap",
    "name": "Database Instance For Sap",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/database-instance-for-sap.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-ddos-protection-plans': {
    "id": "azure-ddos-protection-plans",
    "name": "Ddos Protection Plans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ddos-protection-plans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dedicated-hsm': {
    "id": "azure-dedicated-hsm",
    "name": "Dedicated Hsm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dedicated-hsm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-cm-local-manager': {
    "id": "azure-defender-cm-local-manager",
    "name": "Defender Cm Local Manager",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-cm-local-manager.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-dcs-controller': {
    "id": "azure-defender-dcs-controller",
    "name": "Defender Dcs Controller",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-dcs-controller.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-distributer-control-system': {
    "id": "azure-defender-distributer-control-system",
    "name": "Defender Distributer Control System",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-distributer-control-system.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-engineering-station': {
    "id": "azure-defender-engineering-station",
    "name": "Defender Engineering Station",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-engineering-station.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-external-management': {
    "id": "azure-defender-external-management",
    "name": "Defender External Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-external-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-freezer-monitor': {
    "id": "azure-defender-freezer-monitor",
    "name": "Defender Freezer Monitor",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-freezer-monitor.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-defender-historian': {
    "id": "azure-defender-historian",
    "name": "Defender Historian",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-historian.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-hmi': {
    "id": "azure-defender-hmi",
    "name": "Defender Hmi",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-hmi.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-industrial-packaging-system': {
    "id": "azure-defender-industrial-packaging-system",
    "name": "Defender Industrial Packaging System",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-industrial-packaging-system.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-industrial-printer': {
    "id": "azure-defender-industrial-printer",
    "name": "Defender Industrial Printer",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-industrial-printer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-industrial-robot': {
    "id": "azure-defender-industrial-robot",
    "name": "Defender Industrial Robot",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-industrial-robot.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-industrial-scale-system': {
    "id": "azure-defender-industrial-scale-system",
    "name": "Defender Industrial Scale System",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-industrial-scale-system.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-marquee': {
    "id": "azure-defender-marquee",
    "name": "Defender Marquee",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-marquee.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-meter': {
    "id": "azure-defender-meter",
    "name": "Defender Meter",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-meter.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-plc': {
    "id": "azure-defender-plc",
    "name": "Defender Plc",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-plc.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-pneumatic-device': {
    "id": "azure-defender-pneumatic-device",
    "name": "Defender Pneumatic Device",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-pneumatic-device.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-programable-board': {
    "id": "azure-defender-programable-board",
    "name": "Defender Programable Board",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-programable-board.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-relay': {
    "id": "azure-defender-relay",
    "name": "Defender Relay",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-relay.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-robot-controller': {
    "id": "azure-defender-robot-controller",
    "name": "Defender Robot Controller",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-robot-controller.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-rtu': {
    "id": "azure-defender-rtu",
    "name": "Defender Rtu",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-rtu.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-sensor': {
    "id": "azure-defender-sensor",
    "name": "Defender Sensor",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-sensor.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-slot': {
    "id": "azure-defender-slot",
    "name": "Defender Slot",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-slot.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-defender-web-guiding-system': {
    "id": "azure-defender-web-guiding-system",
    "name": "Defender Web Guiding System",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/defender-web-guiding-system.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-detonation': {
    "id": "azure-detonation",
    "name": "Detonation",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/detonation.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dev-console': {
    "id": "azure-dev-console",
    "name": "Dev Console",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dev-console.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-device-compliance': {
    "id": "azure-device-compliance",
    "name": "Device Compliance",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-compliance.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-device-configuration': {
    "id": "azure-device-configuration",
    "name": "Device Configuration",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-configuration.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-device-enrollment': {
    "id": "azure-device-enrollment",
    "name": "Device Enrollment",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-enrollment.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-device-provisioning-services': {
    "id": "azure-device-provisioning-services",
    "name": "Device Provisioning Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-provisioning-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-device-security-apple': {
    "id": "azure-device-security-apple",
    "name": "Device Security Apple",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-security-apple.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-device-security-google': {
    "id": "azure-device-security-google",
    "name": "Device Security Google",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-security-google.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-device-security-windows': {
    "id": "azure-device-security-windows",
    "name": "Device Security Windows",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-security-windows.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-device-update-iot-hub': {
    "id": "azure-device-update-iot-hub",
    "name": "Device Update Iot Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/device-update-iot-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-devices': {
    "id": "azure-devices",
    "name": "Devices",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/devices.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-devops-starter': {
    "id": "azure-devops-starter",
    "name": "Devops Starter",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/devops-starter.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-devtest-labs': {
    "id": "azure-devtest-labs",
    "name": "Devtest Labs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/devtest-labs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-diagnostics-settings-2': {
    "id": "azure-diagnostics-settings-2",
    "name": "Diagnostics Settings 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/diagnostics-settings-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-diagnostics-settings': {
    "id": "azure-diagnostics-settings",
    "name": "Diagnostics Settings",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/diagnostics-settings.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-digital-twins': {
    "id": "azure-digital-twins",
    "name": "Digital Twins",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/digital-twins.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-disk-encryption-sets': {
    "id": "azure-disk-encryption-sets",
    "name": "Disk Encryption Sets",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/disk-encryption-sets.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-disk-pool': {
    "id": "azure-disk-pool",
    "name": "Disk Pool",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/disk-pool.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-disks-classic': {
    "id": "azure-disks-classic",
    "name": "Disks Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/disks-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-disks-snapshots': {
    "id": "azure-disks-snapshots",
    "name": "Disks Snapshots",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/disks-snapshots.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-disks': {
    "id": "azure-disks",
    "name": "Disks",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/disks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dns-private-resolver': {
    "id": "azure-dns-private-resolver",
    "name": "Dns Private Resolver",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dns-private-resolver.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-dns-zones': {
    "id": "azure-dns-zones",
    "name": "Dns Zones",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/dns-zones.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-download': {
    "id": "azure-download",
    "name": "Download",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/download.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-ebooks': {
    "id": "azure-ebooks",
    "name": "Ebooks",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ebooks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-edge-management': {
    "id": "azure-edge-management",
    "name": "Edge Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/edge-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-education': {
    "id": "azure-education",
    "name": "Education",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/education.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-elastic-job-agents': {
    "id": "azure-elastic-job-agents",
    "name": "Elastic Job Agents",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/elastic-job-agents.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-elastic-san': {
    "id": "azure-elastic-san",
    "name": "Elastic San",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/elastic-san.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-endpoint-analytics': {
    "id": "azure-endpoint-analytics",
    "name": "Endpoint Analytics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/endpoint-analytics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-enterprise-applications': {
    "id": "azure-enterprise-applications",
    "name": "Enterprise Applications",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/enterprise-applications.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-entra-identity': {
    "id": "azure-entra-identity",
    "name": "Entra Identity",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/entra-identity.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-error': {
    "id": "azure-error",
    "name": "Error",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/error.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-grid-domains': {
    "id": "azure-event-grid-domains",
    "name": "Event Grid Domains",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-grid-domains.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-grid-subscriptions-2': {
    "id": "azure-event-grid-subscriptions-2",
    "name": "Event Grid Subscriptions 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-grid-subscriptions-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-grid-subscriptions': {
    "id": "azure-event-grid-subscriptions",
    "name": "Event Grid Subscriptions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-grid-subscriptions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-grid-topics': {
    "id": "azure-event-grid-topics",
    "name": "Event Grid Topics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-grid-topics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-hub-clusters-2': {
    "id": "azure-event-hub-clusters-2",
    "name": "Event Hub Clusters 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-hub-clusters-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-hub-clusters': {
    "id": "azure-event-hub-clusters",
    "name": "Event Hub Clusters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-hub-clusters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-hubs-2': {
    "id": "azure-event-hubs-2",
    "name": "Event Hubs 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-hubs-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-event-hubs': {
    "id": "azure-event-hubs",
    "name": "Event Hubs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/event-hubs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-exchange-access': {
    "id": "azure-exchange-access",
    "name": "Exchange Access",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/exchange-access.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-exchange-on-premises-access': {
    "id": "azure-exchange-on-premises-access",
    "name": "Exchange On Premises Access",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/exchange-on-premises-access.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-express-route-traffic-collector': {
    "id": "azure-express-route-traffic-collector",
    "name": "Express Route Traffic Collector",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/express-route-traffic-collector.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-expressroute-circuits': {
    "id": "azure-expressroute-circuits",
    "name": "Expressroute Circuits",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/expressroute-circuits.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-expressroute-direct': {
    "id": "azure-expressroute-direct",
    "name": "Expressroute Direct",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/expressroute-direct.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-extendedsecurityupdates': {
    "id": "azure-extendedsecurityupdates",
    "name": "Extendedsecurityupdates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/extendedsecurityupdates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-extensions': {
    "id": "azure-extensions",
    "name": "Extensions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/extensions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-external-identities': {
    "id": "azure-external-identities",
    "name": "External Identities",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/external-identities.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-face-apis': {
    "id": "azure-face-apis",
    "name": "Face Apis",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/face-apis.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-feature-previews': {
    "id": "azure-feature-previews",
    "name": "Feature Previews",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/feature-previews.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-fhir-service': {
    "id": "azure-fhir-service",
    "name": "Fhir Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/fhir-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-fiji': {
    "id": "azure-fiji",
    "name": "Fiji",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/fiji.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-file': {
    "id": "azure-file",
    "name": "File",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/file.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-files': {
    "id": "azure-files",
    "name": "Files",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/files.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-firewalls': {
    "id": "azure-firewalls",
    "name": "Firewalls",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/firewalls.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-folder-blank': {
    "id": "azure-folder-blank",
    "name": "Folder Blank",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/folder-blank.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-folder-website': {
    "id": "azure-folder-website",
    "name": "Folder Website",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/folder-website.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-form-recognizers': {
    "id": "azure-form-recognizers",
    "name": "Form Recognizers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/form-recognizers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-free-services': {
    "id": "azure-free-services",
    "name": "Free Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/free-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-front-door-and-cdn-profiles-2': {
    "id": "azure-front-door-and-cdn-profiles-2",
    "name": "Front Door And Cdn Profiles 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/front-door-and-cdn-profiles-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-front-door-and-cdn-profiles': {
    "id": "azure-front-door-and-cdn-profiles",
    "name": "Front Door And Cdn Profiles",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/front-door-and-cdn-profiles.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-ftp': {
    "id": "azure-ftp",
    "name": "Ftp",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ftp.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-function-apps-2': {
    "id": "azure-function-apps-2",
    "name": "Function Apps 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/function-apps-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "serverless",
      "function"
    ]
  },
  'azure-function-apps': {
    "id": "azure-function-apps",
    "name": "Function Apps",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/function-apps.svg",
    "format": "svg",
    "tags": [
      "azure",
      "serverless",
      "function"
    ]
  },
  'azure-gear': {
    "id": "azure-gear",
    "name": "Gear",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/gear.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-genomics-accounts': {
    "id": "azure-genomics-accounts",
    "name": "Genomics Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/genomics-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-genomics': {
    "id": "azure-genomics",
    "name": "Genomics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/genomics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-globe-error': {
    "id": "azure-globe-error",
    "name": "Globe Error",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/globe-error.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-globe-success': {
    "id": "azure-globe-success",
    "name": "Globe Success",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/globe-success.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-globe-warning': {
    "id": "azure-globe-warning",
    "name": "Globe Warning",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/globe-warning.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-groups': {
    "id": "azure-groups",
    "name": "Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-guide': {
    "id": "azure-guide",
    "name": "Guide",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/guide.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-hd-insight-clusters': {
    "id": "azure-hd-insight-clusters",
    "name": "Hd Insight Clusters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/hd-insight-clusters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-heart': {
    "id": "azure-heart",
    "name": "Heart",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/heart.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-help-and-support': {
    "id": "azure-help-and-support",
    "name": "Help And Support",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/help-and-support.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-host-groups': {
    "id": "azure-host-groups",
    "name": "Host Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/host-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-host-pools': {
    "id": "azure-host-pools",
    "name": "Host Pools",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/host-pools.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-hosts': {
    "id": "azure-hosts",
    "name": "Hosts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/hosts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-identity-governance': {
    "id": "azure-identity-governance",
    "name": "Identity Governance",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/identity-governance.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-identity-secure-score': {
    "id": "azure-identity-secure-score",
    "name": "Identity Secure Score",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/identity-secure-score.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-image-definitions': {
    "id": "azure-image-definitions",
    "name": "Image Definitions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/image-definitions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-image-templates': {
    "id": "azure-image-templates",
    "name": "Image Templates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/image-templates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-image-versions': {
    "id": "azure-image-versions",
    "name": "Image Versions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/image-versions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-image': {
    "id": "azure-image",
    "name": "Image",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/image.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-images': {
    "id": "azure-images",
    "name": "Images",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/images.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-immersive-readers': {
    "id": "azure-immersive-readers",
    "name": "Immersive Readers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/immersive-readers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-import-export-jobs': {
    "id": "azure-import-export-jobs",
    "name": "Import Export Jobs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/import-export-jobs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-industrial-iot': {
    "id": "azure-industrial-iot",
    "name": "Industrial Iot",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/industrial-iot.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-information': {
    "id": "azure-information",
    "name": "Information",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/information.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-infrastructure-backup': {
    "id": "azure-infrastructure-backup",
    "name": "Infrastructure Backup",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/infrastructure-backup.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-input-output': {
    "id": "azure-input-output",
    "name": "Input Output",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/input-output.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-instance-pools-2': {
    "id": "azure-instance-pools-2",
    "name": "Instance Pools 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/instance-pools-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-instance-pools': {
    "id": "azure-instance-pools",
    "name": "Instance Pools",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/instance-pools.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-integration-accounts': {
    "id": "azure-integration-accounts",
    "name": "Integration Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/integration-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-integration-service-environments': {
    "id": "azure-integration-service-environments",
    "name": "Integration Service Environments",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/integration-service-environments.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-internet-analyzer-profiles': {
    "id": "azure-internet-analyzer-profiles",
    "name": "Internet Analyzer Profiles",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/internet-analyzer-profiles.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-intune-app-protection': {
    "id": "azure-intune-app-protection",
    "name": "Intune App Protection",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/intune-app-protection.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-intune-for-education': {
    "id": "azure-intune-for-education",
    "name": "Intune For Education",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/intune-for-education.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-intune-trends': {
    "id": "azure-intune-trends",
    "name": "Intune Trends",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/intune-trends.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-intune': {
    "id": "azure-intune",
    "name": "Intune",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/intune.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-iot-central-applications': {
    "id": "azure-iot-central-applications",
    "name": "Iot Central Applications",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/iot-central-applications.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-iot-edge': {
    "id": "azure-iot-edge",
    "name": "Iot Edge",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/iot-edge.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-iot-hub': {
    "id": "azure-iot-hub",
    "name": "Iot Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/iot-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-ip-groups': {
    "id": "azure-ip-groups",
    "name": "Ip Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ip-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-journey-hub': {
    "id": "azure-journey-hub",
    "name": "Journey Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/journey-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-key-vaults': {
    "id": "azure-key-vaults",
    "name": "Key Vaults",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/key-vaults.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-keys': {
    "id": "azure-keys",
    "name": "Keys",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/keys.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-kubernetes-fleet-manager': {
    "id": "azure-kubernetes-fleet-manager",
    "name": "Kubernetes Fleet Manager",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/kubernetes-fleet-manager.svg",
    "format": "svg",
    "tags": [
      "azure",
      "kubernetes"
    ]
  },
  'azure-kubernetes-services-2': {
    "id": "azure-kubernetes-services-2",
    "name": "Kubernetes Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/kubernetes-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "kubernetes"
    ]
  },
  'azure-kubernetes-services': {
    "id": "azure-kubernetes-services",
    "name": "Kubernetes Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/kubernetes-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "kubernetes"
    ]
  },
  'azure-lab-accounts': {
    "id": "azure-lab-accounts",
    "name": "Lab Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/lab-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-lab-services': {
    "id": "azure-lab-services",
    "name": "Lab Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/lab-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-language-understanding': {
    "id": "azure-language-understanding",
    "name": "Language Understanding",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/language-understanding.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-language': {
    "id": "azure-language",
    "name": "Language",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/language.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-launch-portal': {
    "id": "azure-launch-portal",
    "name": "Launch Portal",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/launch-portal.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-learn': {
    "id": "azure-learn",
    "name": "Learn",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/learn.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-load-balancer-hub': {
    "id": "azure-load-balancer-hub",
    "name": "Load Balancer Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/load-balancer-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-load-balancers': {
    "id": "azure-load-balancers",
    "name": "Load Balancers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/load-balancers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-load-test': {
    "id": "azure-load-test",
    "name": "Load Test",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/load-test.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-load-testing': {
    "id": "azure-load-testing",
    "name": "Load Testing",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/load-testing.svg",
    "format": "svg",
    "tags": [
      "azure",
      "load-balancer"
    ]
  },
  'azure-local-network-gateways-2': {
    "id": "azure-local-network-gateways-2",
    "name": "Local Network Gateways 2",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/local-network-gateways-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking",
      "api"
    ]
  },
  'azure-local-network-gateways': {
    "id": "azure-local-network-gateways",
    "name": "Local Network Gateways",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/local-network-gateways.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking",
      "api"
    ]
  },
  'azure-location': {
    "id": "azure-location",
    "name": "Location",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/location.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-log-analytics-query-pack': {
    "id": "azure-log-analytics-query-pack",
    "name": "Log Analytics Query Pack",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/log-analytics-query-pack.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-log-analytics-workspaces-2': {
    "id": "azure-log-analytics-workspaces-2",
    "name": "Log Analytics Workspaces 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/log-analytics-workspaces-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-log-analytics-workspaces-3': {
    "id": "azure-log-analytics-workspaces-3",
    "name": "Log Analytics Workspaces 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/log-analytics-workspaces-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-log-analytics-workspaces': {
    "id": "azure-log-analytics-workspaces",
    "name": "Log Analytics Workspaces",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/log-analytics-workspaces.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-log-streaming': {
    "id": "azure-log-streaming",
    "name": "Log Streaming",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/log-streaming.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-logic-apps-2': {
    "id": "azure-logic-apps-2",
    "name": "Logic Apps 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/logic-apps-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-logic-apps-custom-connector': {
    "id": "azure-logic-apps-custom-connector",
    "name": "Logic Apps Custom Connector",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/logic-apps-custom-connector.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-logic-apps': {
    "id": "azure-logic-apps",
    "name": "Logic Apps",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/logic-apps.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-machine-learning-studio-classic-web-services-2': {
    "id": "azure-machine-learning-studio-classic-web-services-2",
    "name": "Machine Learning Studio Classic Web Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-classic-web-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning-studio-classic-web-services': {
    "id": "azure-machine-learning-studio-classic-web-services",
    "name": "Machine Learning Studio Classic Web Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-classic-web-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning-studio-web-service-plans-2': {
    "id": "azure-machine-learning-studio-web-service-plans-2",
    "name": "Machine Learning Studio Web Service Plans 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-web-service-plans-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning-studio-web-service-plans': {
    "id": "azure-machine-learning-studio-web-service-plans",
    "name": "Machine Learning Studio Web Service Plans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-web-service-plans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning-studio-workspaces-2': {
    "id": "azure-machine-learning-studio-workspaces-2",
    "name": "Machine Learning Studio Workspaces 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-workspaces-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning-studio-workspaces': {
    "id": "azure-machine-learning-studio-workspaces",
    "name": "Machine Learning Studio Workspaces",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning-studio-workspaces.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machine-learning': {
    "id": "azure-machine-learning",
    "name": "Machine Learning",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machine-learning.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-machinesazurearc': {
    "id": "azure-machinesazurearc",
    "name": "Machinesazurearc",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/machinesazurearc.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-maintenance-configuration': {
    "id": "azure-maintenance-configuration",
    "name": "Maintenance Configuration",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/maintenance-configuration.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-managed-applications-center': {
    "id": "azure-managed-applications-center",
    "name": "Managed Applications Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/managed-applications-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-managed-database': {
    "id": "azure-managed-database",
    "name": "Managed Database",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/managed-database.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-managed-desktop': {
    "id": "azure-managed-desktop",
    "name": "Managed Desktop",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/managed-desktop.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-managed-identities': {
    "id": "azure-managed-identities",
    "name": "Managed Identities",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/managed-identities.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-managed-instance-apache-cassandra': {
    "id": "azure-managed-instance-apache-cassandra",
    "name": "Managed Instance Apache Cassandra",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/managed-instance-apache-cassandra.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-managed-service-fabric': {
    "id": "azure-managed-service-fabric",
    "name": "Managed Service Fabric",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/managed-service-fabric.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-management-groups': {
    "id": "azure-management-groups",
    "name": "Management Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/management-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-management-portal': {
    "id": "azure-management-portal",
    "name": "Management Portal",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/management-portal.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-marketplace-management': {
    "id": "azure-marketplace-management",
    "name": "Marketplace Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/marketplace-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-marketplace': {
    "id": "azure-marketplace",
    "name": "Marketplace",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/marketplace.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-media-file': {
    "id": "azure-media-file",
    "name": "Media File",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/media-file.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-media': {
    "id": "azure-media",
    "name": "Media",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/media.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-medtech-service': {
    "id": "azure-medtech-service",
    "name": "Medtech Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/medtech-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-mesh-applications': {
    "id": "azure-mesh-applications",
    "name": "Mesh Applications",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/mesh-applications.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-metrics-2': {
    "id": "azure-metrics-2",
    "name": "Metrics 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/metrics-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-metrics-advisor-2': {
    "id": "azure-metrics-advisor-2",
    "name": "Metrics Advisor 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/metrics-advisor-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-metrics-advisor': {
    "id": "azure-metrics-advisor",
    "name": "Metrics Advisor",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/metrics-advisor.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-metrics': {
    "id": "azure-metrics",
    "name": "Metrics",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/metrics.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-microsoft-defender-easm': {
    "id": "azure-microsoft-defender-easm",
    "name": "Microsoft Defender Easm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/microsoft-defender-easm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-microsoft-defender-for-cloud': {
    "id": "azure-microsoft-defender-for-cloud",
    "name": "Microsoft Defender For Cloud",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/microsoft-defender-for-cloud.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-microsoft-defender-for-iot': {
    "id": "azure-microsoft-defender-for-iot",
    "name": "Microsoft Defender For Iot",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/microsoft-defender-for-iot.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-microsoft-dev-box': {
    "id": "azure-microsoft-dev-box",
    "name": "Microsoft Dev Box",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/microsoft-dev-box.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-mindaro': {
    "id": "azure-mindaro",
    "name": "Mindaro",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/mindaro.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-mission-landing-zone': {
    "id": "azure-mission-landing-zone",
    "name": "Mission Landing Zone",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/mission-landing-zone.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-mobile-engagement': {
    "id": "azure-mobile-engagement",
    "name": "Mobile Engagement",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/mobile-engagement.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-mobile-networks': {
    "id": "azure-mobile-networks",
    "name": "Mobile Networks",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/mobile-networks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-mobile': {
    "id": "azure-mobile",
    "name": "Mobile",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/mobile.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-modular-data-center': {
    "id": "azure-modular-data-center",
    "name": "Modular Data Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/modular-data-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-module': {
    "id": "azure-module",
    "name": "Module",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/module.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-monitor-2': {
    "id": "azure-monitor-2",
    "name": "Monitor 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/monitor-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-monitor': {
    "id": "azure-monitor",
    "name": "Monitor",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/monitor.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-multi-tenancy': {
    "id": "azure-multi-tenancy",
    "name": "Multi Tenancy",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/multi-tenancy.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-multifactor-authentication': {
    "id": "azure-multifactor-authentication",
    "name": "Multifactor Authentication",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/multifactor-authentication.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-my-customers': {
    "id": "azure-my-customers",
    "name": "My Customers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/my-customers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-nat': {
    "id": "azure-nat",
    "name": "Nat",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/nat.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-network-interfaces': {
    "id": "azure-network-interfaces",
    "name": "Network Interfaces",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-interfaces.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-network-managers': {
    "id": "azure-network-managers",
    "name": "Network Managers",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-managers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-network-security-groups': {
    "id": "azure-network-security-groups",
    "name": "Network Security Groups",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-security-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking",
      "security"
    ]
  },
  'azure-network-security-perimeters': {
    "id": "azure-network-security-perimeters",
    "name": "Network Security Perimeters",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-security-perimeters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking",
      "security"
    ]
  },
  'azure-network-watcher-2': {
    "id": "azure-network-watcher-2",
    "name": "Network Watcher 2",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-watcher-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-network-watcher': {
    "id": "azure-network-watcher",
    "name": "Network Watcher",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/network-watcher.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-notification-hub-namespaces-2': {
    "id": "azure-notification-hub-namespaces-2",
    "name": "Notification Hub Namespaces 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/notification-hub-namespaces-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-notification-hub-namespaces': {
    "id": "azure-notification-hub-namespaces",
    "name": "Notification Hub Namespaces",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/notification-hub-namespaces.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-notification-hubs-2': {
    "id": "azure-notification-hubs-2",
    "name": "Notification Hubs 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/notification-hubs-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-notification-hubs-3': {
    "id": "azure-notification-hubs-3",
    "name": "Notification Hubs 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/notification-hubs-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-notification-hubs': {
    "id": "azure-notification-hubs",
    "name": "Notification Hubs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/notification-hubs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-offers': {
    "id": "azure-offers",
    "name": "Offers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/offers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-on-premises-data-gateways': {
    "id": "azure-on-premises-data-gateways",
    "name": "On Premises Data Gateways",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/on-premises-data-gateways.svg",
    "format": "svg",
    "tags": [
      "azure",
      "api"
    ]
  },
  'azure-open-supply-chain-platform': {
    "id": "azure-open-supply-chain-platform",
    "name": "Open Supply Chain Platform",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/open-supply-chain-platform.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-operation-log-classic': {
    "id": "azure-operation-log-classic",
    "name": "Operation Log Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/operation-log-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-os-images-classic': {
    "id": "azure-os-images-classic",
    "name": "Os Images Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/os-images-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-outbound-connection': {
    "id": "azure-outbound-connection",
    "name": "Outbound Connection",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/outbound-connection.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-partner-namespace': {
    "id": "azure-partner-namespace",
    "name": "Partner Namespace",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/partner-namespace.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-partner-registration': {
    "id": "azure-partner-registration",
    "name": "Partner Registration",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/partner-registration.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-partner-topic': {
    "id": "azure-partner-topic",
    "name": "Partner Topic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/partner-topic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-peering-service': {
    "id": "azure-peering-service",
    "name": "Peering Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/peering-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-peerings': {
    "id": "azure-peerings",
    "name": "Peerings",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/peerings.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-personalizers': {
    "id": "azure-personalizers",
    "name": "Personalizers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/personalizers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-plans': {
    "id": "azure-plans",
    "name": "Plans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/plans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-policy': {
    "id": "azure-policy",
    "name": "Policy",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/policy.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-bi-embedded': {
    "id": "azure-power-bi-embedded",
    "name": "Power Bi Embedded",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-bi-embedded.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-platform-2': {
    "id": "azure-power-platform-2",
    "name": "Power Platform 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-platform-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-platform-3': {
    "id": "azure-power-platform-3",
    "name": "Power Platform 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-platform-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-platform-4': {
    "id": "azure-power-platform-4",
    "name": "Power Platform 4",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-platform-4.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-platform': {
    "id": "azure-power-platform",
    "name": "Power Platform",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-platform.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power-up': {
    "id": "azure-power-up",
    "name": "Power Up",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power-up.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-power': {
    "id": "azure-power",
    "name": "Power",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/power.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-powershell': {
    "id": "azure-powershell",
    "name": "Powershell",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/powershell.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-preview-features': {
    "id": "azure-preview-features",
    "name": "Preview Features",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/preview-features.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-private-endpoints': {
    "id": "azure-private-endpoints",
    "name": "Private Endpoints",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/private-endpoints.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-private-link-service': {
    "id": "azure-private-link-service",
    "name": "Private Link Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/private-link-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-private-link-services-2': {
    "id": "azure-private-link-services-2",
    "name": "Private Link Services 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/private-link-services-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-private-link-services': {
    "id": "azure-private-link-services",
    "name": "Private Link Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/private-link-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-private-link': {
    "id": "azure-private-link",
    "name": "Private Link",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/private-link.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-process-explorer': {
    "id": "azure-process-explorer",
    "name": "Process Explorer",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/process-explorer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-production-ready-database': {
    "id": "azure-production-ready-database",
    "name": "Production Ready Database",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/production-ready-database.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-proximity-placement-groups': {
    "id": "azure-proximity-placement-groups",
    "name": "Proximity Placement Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/proximity-placement-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-public-ip-addresses-classic': {
    "id": "azure-public-ip-addresses-classic",
    "name": "Public Ip Addresses Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/public-ip-addresses-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-public-ip-addresses': {
    "id": "azure-public-ip-addresses",
    "name": "Public Ip Addresses",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/public-ip-addresses.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-public-ip-prefixes': {
    "id": "azure-public-ip-prefixes",
    "name": "Public Ip Prefixes",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/public-ip-prefixes.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-qna-makers': {
    "id": "azure-qna-makers",
    "name": "Qna Makers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/qna-makers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-quickstart-center': {
    "id": "azure-quickstart-center",
    "name": "Quickstart Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/quickstart-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-recent': {
    "id": "azure-recent",
    "name": "Recent",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/recent.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-recovery-services-vaults-2': {
    "id": "azure-recovery-services-vaults-2",
    "name": "Recovery Services Vaults 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/recovery-services-vaults-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-recovery-services-vaults-3': {
    "id": "azure-recovery-services-vaults-3",
    "name": "Recovery Services Vaults 3",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/recovery-services-vaults-3.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-recovery-services-vaults': {
    "id": "azure-recovery-services-vaults",
    "name": "Recovery Services Vaults",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/recovery-services-vaults.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-region-management': {
    "id": "azure-region-management",
    "name": "Region Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/region-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-relays': {
    "id": "azure-relays",
    "name": "Relays",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/relays.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-remote-rendering': {
    "id": "azure-remote-rendering",
    "name": "Remote Rendering",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/remote-rendering.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-reservations': {
    "id": "azure-reservations",
    "name": "Reservations",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/reservations.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-reserved-capacity': {
    "id": "azure-reserved-capacity",
    "name": "Reserved Capacity",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/reserved-capacity.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-reserved-ip-addresses-classic': {
    "id": "azure-reserved-ip-addresses-classic",
    "name": "Reserved Ip Addresses Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/reserved-ip-addresses-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-explorer': {
    "id": "azure-resource-explorer",
    "name": "Resource Explorer",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-explorer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-graph-explorer': {
    "id": "azure-resource-graph-explorer",
    "name": "Resource Graph Explorer",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-graph-explorer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-group-list': {
    "id": "azure-resource-group-list",
    "name": "Resource Group List",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-group-list.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-groups': {
    "id": "azure-resource-groups",
    "name": "Resource Groups",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-groups.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-guard': {
    "id": "azure-resource-guard",
    "name": "Resource Guard",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-guard.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-linked': {
    "id": "azure-resource-linked",
    "name": "Resource Linked",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-linked.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-management-private-link': {
    "id": "azure-resource-management-private-link",
    "name": "Resource Management Private Link",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-management-private-link.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-resource-mover': {
    "id": "azure-resource-mover",
    "name": "Resource Mover",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/resource-mover.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-restore-points-collections': {
    "id": "azure-restore-points-collections",
    "name": "Restore Points Collections",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/restore-points-collections.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-restore-points': {
    "id": "azure-restore-points",
    "name": "Restore Points",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/restore-points.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-route-filters': {
    "id": "azure-route-filters",
    "name": "Route Filters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/route-filters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-route-tables': {
    "id": "azure-route-tables",
    "name": "Route Tables",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/route-tables.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-rtos': {
    "id": "azure-rtos",
    "name": "Rtos",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/rtos.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-savings-plans': {
    "id": "azure-savings-plans",
    "name": "Savings Plans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/savings-plans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-scheduler-job-collections': {
    "id": "azure-scheduler-job-collections",
    "name": "Scheduler Job Collections",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/scheduler-job-collections.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-scheduler': {
    "id": "azure-scheduler",
    "name": "Scheduler",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/scheduler.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-scvmm-management-servers': {
    "id": "azure-scvmm-management-servers",
    "name": "Scvmm Management Servers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/scvmm-management-servers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-search-grid': {
    "id": "azure-search-grid",
    "name": "Search Grid",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/search-grid.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-search': {
    "id": "azure-search",
    "name": "Search",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/search.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-security-baselines': {
    "id": "azure-security-baselines",
    "name": "Security Baselines",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/security-baselines.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-security': {
    "id": "azure-security",
    "name": "Security",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/security.svg",
    "format": "svg",
    "tags": [
      "azure",
      "security"
    ]
  },
  'azure-sendgrid-accounts': {
    "id": "azure-sendgrid-accounts",
    "name": "Sendgrid Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sendgrid-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-server-farm': {
    "id": "azure-server-farm",
    "name": "Server Farm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/server-farm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-service-catalog-mad': {
    "id": "azure-service-catalog-mad",
    "name": "Service Catalog Mad",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-catalog-mad.svg",
    "format": "svg",
    "tags": [
      "azure",
      "monitoring"
    ]
  },
  'azure-service-endpoint-policies': {
    "id": "azure-service-endpoint-policies",
    "name": "Service Endpoint Policies",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-endpoint-policies.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-service-fabric-clusters-2': {
    "id": "azure-service-fabric-clusters-2",
    "name": "Service Fabric Clusters 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-fabric-clusters-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-service-fabric-clusters': {
    "id": "azure-service-fabric-clusters",
    "name": "Service Fabric Clusters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-fabric-clusters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-service-health': {
    "id": "azure-service-health",
    "name": "Service Health",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-health.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-service-providers': {
    "id": "azure-service-providers",
    "name": "Service Providers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/service-providers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-shared-image-galleries': {
    "id": "azure-shared-image-galleries",
    "name": "Shared Image Galleries",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/shared-image-galleries.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-signalr': {
    "id": "azure-signalr",
    "name": "Signalr",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/signalr.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-software-as-a-service': {
    "id": "azure-software-as-a-service",
    "name": "Software As A Service",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/software-as-a-service.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-software-updates': {
    "id": "azure-software-updates",
    "name": "Software Updates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/software-updates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-solutions': {
    "id": "azure-solutions",
    "name": "Solutions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/solutions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sonic-dash': {
    "id": "azure-sonic-dash",
    "name": "Sonic Dash",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sonic-dash.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-spatial-anchor-accounts': {
    "id": "azure-spatial-anchor-accounts",
    "name": "Spatial Anchor Accounts",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/spatial-anchor-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-speech-services': {
    "id": "azure-speech-services",
    "name": "Speech Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/speech-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-spot-vm': {
    "id": "azure-spot-vm",
    "name": "Spot Vm",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/spot-vm.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-spot-vmss': {
    "id": "azure-spot-vmss",
    "name": "Spot Vmss",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/spot-vmss.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-sql-data-warehouses-2': {
    "id": "azure-sql-data-warehouses-2",
    "name": "Sql Data Warehouses 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-data-warehouses-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sql-data-warehouses': {
    "id": "azure-sql-data-warehouses",
    "name": "Sql Data Warehouses",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-data-warehouses.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sql-database': {
    "id": "azure-sql-database",
    "name": "Sql Database",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/sql-database.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-sql-elastic-pools': {
    "id": "azure-sql-elastic-pools",
    "name": "Sql Elastic Pools",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-elastic-pools.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sql-managed-instance': {
    "id": "azure-sql-managed-instance",
    "name": "Sql Managed Instance",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-managed-instance.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sql-server-registries': {
    "id": "azure-sql-server-registries",
    "name": "Sql Server Registries",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-server-registries.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-sql-server': {
    "id": "azure-sql-server",
    "name": "Sql Server",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/sql-server.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-ssd': {
    "id": "azure-ssd",
    "name": "Ssd",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ssd.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-ssh-keys': {
    "id": "azure-ssh-keys",
    "name": "Ssh Keys",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ssh-keys.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-ssis-lift-and-shift-ir': {
    "id": "azure-ssis-lift-and-shift-ir",
    "name": "Ssis Lift And Shift Ir",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/ssis-lift-and-shift-ir.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-static-apps': {
    "id": "azure-static-apps",
    "name": "Static Apps",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/static-apps.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-storage-accounts-classic': {
    "id": "azure-storage-accounts-classic",
    "name": "Storage Accounts Classic",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-accounts-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storage-accounts': {
    "id": "azure-storage-accounts",
    "name": "Storage Accounts",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-accounts.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storage-azure-files': {
    "id": "azure-storage-azure-files",
    "name": "Storage Azure Files",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-azure-files.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storage-container': {
    "id": "azure-storage-container",
    "name": "Storage Container",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-container.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage",
      "container"
    ]
  },
  'azure-storage-explorer': {
    "id": "azure-storage-explorer",
    "name": "Storage Explorer",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-explorer.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storage-queue': {
    "id": "azure-storage-queue",
    "name": "Storage Queue",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-queue.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage",
      "queue",
      "messaging"
    ]
  },
  'azure-storage-sync-services': {
    "id": "azure-storage-sync-services",
    "name": "Storage Sync Services",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-sync-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storage-tasks': {
    "id": "azure-storage-tasks",
    "name": "Storage Tasks",
    "provider": "azure",
    "category": "storage",
    "path": "/icons/azure/storage-tasks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "storage"
    ]
  },
  'azure-storsimple-data-managers': {
    "id": "azure-storsimple-data-managers",
    "name": "Storsimple Data Managers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/storsimple-data-managers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-storsimple-device-managers-2': {
    "id": "azure-storsimple-device-managers-2",
    "name": "Storsimple Device Managers 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/storsimple-device-managers-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-storsimple-device-managers': {
    "id": "azure-storsimple-device-managers",
    "name": "Storsimple Device Managers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/storsimple-device-managers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-stream-analytics-jobs-2': {
    "id": "azure-stream-analytics-jobs-2",
    "name": "Stream Analytics Jobs 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/stream-analytics-jobs-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-stream-analytics-jobs': {
    "id": "azure-stream-analytics-jobs",
    "name": "Stream Analytics Jobs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/stream-analytics-jobs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-subnet': {
    "id": "azure-subnet",
    "name": "Subnet",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/subnet.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-subscriptions': {
    "id": "azure-subscriptions",
    "name": "Subscriptions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/subscriptions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-system-topic': {
    "id": "azure-system-topic",
    "name": "System Topic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/system-topic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-table': {
    "id": "azure-table",
    "name": "Table",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/table.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-tag': {
    "id": "azure-tag",
    "name": "Tag",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/tag.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-tags': {
    "id": "azure-tags",
    "name": "Tags",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/tags.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-targets-management': {
    "id": "azure-targets-management",
    "name": "Targets Management",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/targets-management.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-template-specs': {
    "id": "azure-template-specs",
    "name": "Template Specs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/template-specs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-templates': {
    "id": "azure-templates",
    "name": "Templates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/templates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-tenant-properties': {
    "id": "azure-tenant-properties",
    "name": "Tenant Properties",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/tenant-properties.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-tenant-status': {
    "id": "azure-tenant-status",
    "name": "Tenant Status",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/tenant-status.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-test-base': {
    "id": "azure-test-base",
    "name": "Test Base",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/test-base.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-tfs-vc-repository': {
    "id": "azure-tfs-vc-repository",
    "name": "Tfs Vc Repository",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/tfs-vc-repository.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-time-series-data-sets': {
    "id": "azure-time-series-data-sets",
    "name": "Time Series Data Sets",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/time-series-data-sets.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-time-series-insights-access-policies': {
    "id": "azure-time-series-insights-access-policies",
    "name": "Time Series Insights Access Policies",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/time-series-insights-access-policies.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-time-series-insights-environments': {
    "id": "azure-time-series-insights-environments",
    "name": "Time Series Insights Environments",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/time-series-insights-environments.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-time-series-insights-event-sources': {
    "id": "azure-time-series-insights-event-sources",
    "name": "Time Series Insights Event Sources",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/time-series-insights-event-sources.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-toolbox': {
    "id": "azure-toolbox",
    "name": "Toolbox",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/toolbox.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-traffic-manager-profiles': {
    "id": "azure-traffic-manager-profiles",
    "name": "Traffic Manager Profiles",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/traffic-manager-profiles.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-translator-text': {
    "id": "azure-translator-text",
    "name": "Translator Text",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/translator-text.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-troubleshoot': {
    "id": "azure-troubleshoot",
    "name": "Troubleshoot",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/troubleshoot.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-universal-print': {
    "id": "azure-universal-print",
    "name": "Universal Print",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/universal-print.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-update-management-center': {
    "id": "azure-update-management-center",
    "name": "Update Management Center",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/update-management-center.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-updates': {
    "id": "azure-updates",
    "name": "Updates",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/updates.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-user-privacy': {
    "id": "azure-user-privacy",
    "name": "User Privacy",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/user-privacy.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-user-settings-2': {
    "id": "azure-user-settings-2",
    "name": "User Settings 2",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/user-settings-2.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-user-settings': {
    "id": "azure-user-settings",
    "name": "User Settings",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/user-settings.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-user-subscriptions': {
    "id": "azure-user-subscriptions",
    "name": "User Subscriptions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/user-subscriptions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-users': {
    "id": "azure-users",
    "name": "Users",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/users.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-verifiable-credentials': {
    "id": "azure-verifiable-credentials",
    "name": "Verifiable Credentials",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/verifiable-credentials.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-versions': {
    "id": "azure-versions",
    "name": "Versions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/versions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-video-analyzers': {
    "id": "azure-video-analyzers",
    "name": "Video Analyzers",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/video-analyzers.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-clusters': {
    "id": "azure-virtual-clusters",
    "name": "Virtual Clusters",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-clusters.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-instance-for-sap': {
    "id": "azure-virtual-instance-for-sap",
    "name": "Virtual Instance For Sap",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-instance-for-sap.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-machine': {
    "id": "azure-virtual-machine",
    "name": "Virtual Machine",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-machine.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-machines-classic': {
    "id": "azure-virtual-machines-classic",
    "name": "Virtual Machines Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-machines-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-network-gateways': {
    "id": "azure-virtual-network-gateways",
    "name": "Virtual Network Gateways",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/virtual-network-gateways.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking",
      "api"
    ]
  },
  'azure-virtual-networks-classic': {
    "id": "azure-virtual-networks-classic",
    "name": "Virtual Networks Classic",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/virtual-networks-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-virtual-networks': {
    "id": "azure-virtual-networks",
    "name": "Virtual Networks",
    "provider": "azure",
    "category": "networking",
    "path": "/icons/azure/virtual-networks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "networking"
    ]
  },
  'azure-virtual-router': {
    "id": "azure-virtual-router",
    "name": "Virtual Router",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-router.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-visits-builder': {
    "id": "azure-virtual-visits-builder",
    "name": "Virtual Visits Builder",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-visits-builder.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-wan-hub': {
    "id": "azure-virtual-wan-hub",
    "name": "Virtual Wan Hub",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-wan-hub.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-virtual-wans': {
    "id": "azure-virtual-wans",
    "name": "Virtual Wans",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/virtual-wans.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-vm-app-definitions': {
    "id": "azure-vm-app-definitions",
    "name": "Vm App Definitions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/vm-app-definitions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-vm-app-versions': {
    "id": "azure-vm-app-versions",
    "name": "Vm App Versions",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/vm-app-versions.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-vm-image-version': {
    "id": "azure-vm-image-version",
    "name": "Vm Image Version",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/vm-image-version.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-vm-images-classic': {
    "id": "azure-vm-images-classic",
    "name": "Vm Images Classic",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/vm-images-classic.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-vm-scale-sets': {
    "id": "azure-vm-scale-sets",
    "name": "Vm Scale Sets",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/vm-scale-sets.svg",
    "format": "svg",
    "tags": [
      "azure",
      "compute",
      "server"
    ]
  },
  'azure-wac': {
    "id": "azure-wac",
    "name": "Wac",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/wac.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-web-app-database': {
    "id": "azure-web-app-database",
    "name": "Web App Database",
    "provider": "azure",
    "category": "database",
    "path": "/icons/azure/web-app-database.svg",
    "format": "svg",
    "tags": [
      "azure",
      "database"
    ]
  },
  'azure-web-application-firewall-policies-waf': {
    "id": "azure-web-application-firewall-policies-waf",
    "name": "Web Application Firewall Policies Waf",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/web-application-firewall-policies-waf.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-web-jobs': {
    "id": "azure-web-jobs",
    "name": "Web Jobs",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/web-jobs.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-web-slots': {
    "id": "azure-web-slots",
    "name": "Web Slots",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/web-slots.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-web-test': {
    "id": "azure-web-test",
    "name": "Web Test",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/web-test.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-website-power': {
    "id": "azure-website-power",
    "name": "Website Power",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/website-power.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-website-staging': {
    "id": "azure-website-staging",
    "name": "Website Staging",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/website-staging.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-windows-notification-services': {
    "id": "azure-windows-notification-services",
    "name": "Windows Notification Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/windows-notification-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-windows10-core-services': {
    "id": "azure-windows10-core-services",
    "name": "Windows10 Core Services",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/windows10-core-services.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-workbooks': {
    "id": "azure-workbooks",
    "name": "Workbooks",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/workbooks.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-worker-container-app': {
    "id": "azure-worker-container-app",
    "name": "Worker Container App",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/worker-container-app.svg",
    "format": "svg",
    "tags": [
      "azure",
      "container"
    ]
  },
  'azure-workflow': {
    "id": "azure-workflow",
    "name": "Workflow",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/workflow.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },
  'azure-workspaces': {
    "id": "azure-workspaces",
    "name": "Workspaces",
    "provider": "azure",
    "category": "service",
    "path": "/icons/azure/workspaces.svg",
    "format": "svg",
    "tags": [
      "azure",
      "service"
    ]
  },

  // GCP (216 icons)
  'gcp-access-context-manager': {
    "id": "gcp-access-context-manager",
    "name": "Access Context Manager",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/access-context-manager.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-administration': {
    "id": "gcp-administration",
    "name": "Administration",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/administration.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-advanced-agent-modeling': {
    "id": "gcp-advanced-agent-modeling",
    "name": "Advanced Agent Modeling",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/advanced-agent-modeling.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-advanced-solutions-lab': {
    "id": "gcp-advanced-solutions-lab",
    "name": "Advanced Solutions Lab",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/advanced-solutions-lab.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-agent-assist': {
    "id": "gcp-agent-assist",
    "name": "Agent Assist",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/agent-assist.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  // ... 211 more gcp icons
  'gcp-ai-hub': {
    "id": "gcp-ai-hub",
    "name": "Ai Hub",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/ai-hub.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-ai-platform-unified': {
    "id": "gcp-ai-platform-unified",
    "name": "Ai Platform Unified",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/ai-platform-unified.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-ai-platform': {
    "id": "gcp-ai-platform",
    "name": "Ai Platform",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/ai-platform.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-analytics-hub': {
    "id": "gcp-analytics-hub",
    "name": "Analytics Hub",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/analytics-hub.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-anthos-config-management': {
    "id": "gcp-anthos-config-management",
    "name": "Anthos Config Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/anthos-config-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-anthos-service-mesh': {
    "id": "gcp-anthos-service-mesh",
    "name": "Anthos Service Mesh",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/anthos-service-mesh.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-anthos': {
    "id": "gcp-anthos",
    "name": "Anthos",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/anthos.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-api-analytics': {
    "id": "gcp-api-analytics",
    "name": "Api Analytics",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/api-analytics.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-api-monetization': {
    "id": "gcp-api-monetization",
    "name": "Api Monetization",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/api-monetization.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-api': {
    "id": "gcp-api",
    "name": "Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-apigee-api-platform': {
    "id": "gcp-apigee-api-platform",
    "name": "Apigee Api Platform",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/apigee-api-platform.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-apigee-sense': {
    "id": "gcp-apigee-sense",
    "name": "Apigee Sense",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/apigee-sense.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-app-engine': {
    "id": "gcp-app-engine",
    "name": "App Engine",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/app-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-artifact-registry': {
    "id": "gcp-artifact-registry",
    "name": "Artifact Registry",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/artifact-registry.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-asset-inventory': {
    "id": "gcp-asset-inventory",
    "name": "Asset Inventory",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/asset-inventory.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-assured-workloads': {
    "id": "gcp-assured-workloads",
    "name": "Assured Workloads",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/assured-workloads.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "load-balancer"
    ]
  },
  'gcp-automl-natural-language': {
    "id": "gcp-automl-natural-language",
    "name": "Automl Natural Language",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl-natural-language.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-automl-tables': {
    "id": "gcp-automl-tables",
    "name": "Automl Tables",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl-tables.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-automl-translation': {
    "id": "gcp-automl-translation",
    "name": "Automl Translation",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl-translation.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-automl-video-intelligence': {
    "id": "gcp-automl-video-intelligence",
    "name": "Automl Video Intelligence",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl-video-intelligence.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-automl-vision': {
    "id": "gcp-automl-vision",
    "name": "Automl Vision",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl-vision.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-automl': {
    "id": "gcp-automl",
    "name": "Automl",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/automl.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-bare-metal-solutions': {
    "id": "gcp-bare-metal-solutions",
    "name": "Bare Metal Solutions",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/bare-metal-solutions.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-batch': {
    "id": "gcp-batch",
    "name": "Batch",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/batch.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-beyondcorp': {
    "id": "gcp-beyondcorp",
    "name": "Beyondcorp",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/beyondcorp.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-bigquery': {
    "id": "gcp-bigquery",
    "name": "Bigquery",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/bigquery.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-bigtable': {
    "id": "gcp-bigtable",
    "name": "Bigtable",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/bigtable.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-billing': {
    "id": "gcp-billing",
    "name": "Billing",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/billing.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-binary-authorization': {
    "id": "gcp-binary-authorization",
    "name": "Binary Authorization",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/binary-authorization.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-catalog': {
    "id": "gcp-catalog",
    "name": "Catalog",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/catalog.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-certificate-authority-service': {
    "id": "gcp-certificate-authority-service",
    "name": "Certificate Authority Service",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/certificate-authority-service.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-certificate-manager': {
    "id": "gcp-certificate-manager",
    "name": "Certificate Manager",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/certificate-manager.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-api-gateway': {
    "id": "gcp-cloud-api-gateway",
    "name": "Cloud Api Gateway",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-api-gateway.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-apis': {
    "id": "gcp-cloud-apis",
    "name": "Cloud Apis",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-apis.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-armor': {
    "id": "gcp-cloud-armor",
    "name": "Cloud Armor",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-armor.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-asset-inventory': {
    "id": "gcp-cloud-asset-inventory",
    "name": "Cloud Asset Inventory",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-asset-inventory.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-audit-logs': {
    "id": "gcp-cloud-audit-logs",
    "name": "Cloud Audit Logs",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-audit-logs.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-cloud-build': {
    "id": "gcp-cloud-build",
    "name": "Cloud Build",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-build.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-cdn': {
    "id": "gcp-cloud-cdn",
    "name": "Cloud Cdn",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-cdn.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-cloud-code': {
    "id": "gcp-cloud-code",
    "name": "Cloud Code",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-code.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-composer': {
    "id": "gcp-cloud-composer",
    "name": "Cloud Composer",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-composer.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-data-fusion': {
    "id": "gcp-cloud-data-fusion",
    "name": "Cloud Data Fusion",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-data-fusion.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-deploy': {
    "id": "gcp-cloud-deploy",
    "name": "Cloud Deploy",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-deploy.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-deployment-manager': {
    "id": "gcp-cloud-deployment-manager",
    "name": "Cloud Deployment Manager",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-deployment-manager.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-dns': {
    "id": "gcp-cloud-dns",
    "name": "Cloud Dns",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-dns.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-domains': {
    "id": "gcp-cloud-domains",
    "name": "Cloud Domains",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-domains.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-ekm': {
    "id": "gcp-cloud-ekm",
    "name": "Cloud Ekm",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-ekm.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-endpoints': {
    "id": "gcp-cloud-endpoints",
    "name": "Cloud Endpoints",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-endpoints.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-external-ip-addresses': {
    "id": "gcp-cloud-external-ip-addresses",
    "name": "Cloud External Ip Addresses",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-external-ip-addresses.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-firewall-rules': {
    "id": "gcp-cloud-firewall-rules",
    "name": "Cloud Firewall Rules",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-firewall-rules.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-for-marketing': {
    "id": "gcp-cloud-for-marketing",
    "name": "Cloud For Marketing",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-for-marketing.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-functions': {
    "id": "gcp-cloud-functions",
    "name": "Cloud Functions",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-functions.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "serverless",
      "function"
    ]
  },
  'gcp-cloud-generic': {
    "id": "gcp-cloud-generic",
    "name": "Cloud Generic",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-generic.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-gpu': {
    "id": "gcp-cloud-gpu",
    "name": "Cloud Gpu",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-gpu.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-healthcare-api': {
    "id": "gcp-cloud-healthcare-api",
    "name": "Cloud Healthcare Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-healthcare-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-healthcare-marketplace': {
    "id": "gcp-cloud-healthcare-marketplace",
    "name": "Cloud Healthcare Marketplace",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-healthcare-marketplace.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-hsm': {
    "id": "gcp-cloud-hsm",
    "name": "Cloud Hsm",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-hsm.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-ids': {
    "id": "gcp-cloud-ids",
    "name": "Cloud Ids",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-ids.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-inference-api': {
    "id": "gcp-cloud-inference-api",
    "name": "Cloud Inference Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-inference-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-interconnect': {
    "id": "gcp-cloud-interconnect",
    "name": "Cloud Interconnect",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-interconnect.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-jobs-api': {
    "id": "gcp-cloud-jobs-api",
    "name": "Cloud Jobs Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-jobs-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-load-balancing': {
    "id": "gcp-cloud-load-balancing",
    "name": "Cloud Load Balancing",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-load-balancing.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "load-balancer"
    ]
  },
  'gcp-cloud-logging': {
    "id": "gcp-cloud-logging",
    "name": "Cloud Logging",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-logging.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-cloud-media-edge': {
    "id": "gcp-cloud-media-edge",
    "name": "Cloud Media Edge",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-media-edge.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-monitoring': {
    "id": "gcp-cloud-monitoring",
    "name": "Cloud Monitoring",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-monitoring.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-cloud-nat': {
    "id": "gcp-cloud-nat",
    "name": "Cloud Nat",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-nat.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-natural-language-api': {
    "id": "gcp-cloud-natural-language-api",
    "name": "Cloud Natural Language Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-natural-language-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-network': {
    "id": "gcp-cloud-network",
    "name": "Cloud Network",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/cloud-network.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-cloud-ops': {
    "id": "gcp-cloud-ops",
    "name": "Cloud Ops",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-ops.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-optimization-ai-fleet-routing-api': {
    "id": "gcp-cloud-optimization-ai-fleet-routing-api",
    "name": "Cloud Optimization Ai Fleet Routing Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-optimization-ai-fleet-routing-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-optimization-ai': {
    "id": "gcp-cloud-optimization-ai",
    "name": "Cloud Optimization Ai",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-optimization-ai.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-router': {
    "id": "gcp-cloud-router",
    "name": "Cloud Router",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-router.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-routes': {
    "id": "gcp-cloud-routes",
    "name": "Cloud Routes",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-routes.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-run-for-anthos': {
    "id": "gcp-cloud-run-for-anthos",
    "name": "Cloud Run For Anthos",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-run-for-anthos.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-run': {
    "id": "gcp-cloud-run",
    "name": "Cloud Run",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-run.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-scheduler': {
    "id": "gcp-cloud-scheduler",
    "name": "Cloud Scheduler",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-scheduler.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-security-scanner': {
    "id": "gcp-cloud-security-scanner",
    "name": "Cloud Security Scanner",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-security-scanner.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-cloud-shell': {
    "id": "gcp-cloud-shell",
    "name": "Cloud Shell",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-shell.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-spanner': {
    "id": "gcp-cloud-spanner",
    "name": "Cloud Spanner",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-spanner.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-sql': {
    "id": "gcp-cloud-sql",
    "name": "Cloud Sql",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-sql.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-storage': {
    "id": "gcp-cloud-storage",
    "name": "Cloud Storage",
    "provider": "gcp",
    "category": "storage",
    "path": "/icons/gcp/cloud-storage.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "storage"
    ]
  },
  'gcp-cloud-tasks': {
    "id": "gcp-cloud-tasks",
    "name": "Cloud Tasks",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-tasks.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-test-lab': {
    "id": "gcp-cloud-test-lab",
    "name": "Cloud Test Lab",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-test-lab.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-tpu': {
    "id": "gcp-cloud-tpu",
    "name": "Cloud Tpu",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-tpu.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-cloud-translation-api': {
    "id": "gcp-cloud-translation-api",
    "name": "Cloud Translation Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-translation-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-vision-api': {
    "id": "gcp-cloud-vision-api",
    "name": "Cloud Vision Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-vision-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-cloud-vpn': {
    "id": "gcp-cloud-vpn",
    "name": "Cloud Vpn",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/cloud-vpn.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-compute-engine': {
    "id": "gcp-compute-engine",
    "name": "Compute Engine",
    "provider": "gcp",
    "category": "compute",
    "path": "/icons/gcp/compute-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "compute",
      "server"
    ]
  },
  'gcp-configuration-management': {
    "id": "gcp-configuration-management",
    "name": "Configuration Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/configuration-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-connectivity-test': {
    "id": "gcp-connectivity-test",
    "name": "Connectivity Test",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/connectivity-test.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-connectors': {
    "id": "gcp-connectors",
    "name": "Connectors",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/connectors.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-contact-center-ai': {
    "id": "gcp-contact-center-ai",
    "name": "Contact Center Ai",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/contact-center-ai.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-container-optimized-os': {
    "id": "gcp-container-optimized-os",
    "name": "Container Optimized Os",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/container-optimized-os.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "container"
    ]
  },
  'gcp-container-registry': {
    "id": "gcp-container-registry",
    "name": "Container Registry",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/container-registry.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "container"
    ]
  },
  'gcp-data-catalog': {
    "id": "gcp-data-catalog",
    "name": "Data Catalog",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-catalog.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-data-labeling': {
    "id": "gcp-data-labeling",
    "name": "Data Labeling",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-labeling.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-data-layers': {
    "id": "gcp-data-layers",
    "name": "Data Layers",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-layers.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-data-loss-prevention-api': {
    "id": "gcp-data-loss-prevention-api",
    "name": "Data Loss Prevention Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-loss-prevention-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-data-qna': {
    "id": "gcp-data-qna",
    "name": "Data Qna",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-qna.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-data-studio': {
    "id": "gcp-data-studio",
    "name": "Data Studio",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-studio.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-data-transfer': {
    "id": "gcp-data-transfer",
    "name": "Data Transfer",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/data-transfer.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-database-migration-service': {
    "id": "gcp-database-migration-service",
    "name": "Database Migration Service",
    "provider": "gcp",
    "category": "database",
    "path": "/icons/gcp/database-migration-service.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "database"
    ]
  },
  'gcp-dataflow': {
    "id": "gcp-dataflow",
    "name": "Dataflow",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dataflow.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-datalab': {
    "id": "gcp-datalab",
    "name": "Datalab",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/datalab.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-dataplex': {
    "id": "gcp-dataplex",
    "name": "Dataplex",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dataplex.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-datapol': {
    "id": "gcp-datapol",
    "name": "Datapol",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/datapol.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-dataprep': {
    "id": "gcp-dataprep",
    "name": "Dataprep",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dataprep.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-dataproc-metastore': {
    "id": "gcp-dataproc-metastore",
    "name": "Dataproc Metastore",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dataproc-metastore.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-dataproc': {
    "id": "gcp-dataproc",
    "name": "Dataproc",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dataproc.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-datashare': {
    "id": "gcp-datashare",
    "name": "Datashare",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/datashare.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-datastore': {
    "id": "gcp-datastore",
    "name": "Datastore",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/datastore.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-datastream': {
    "id": "gcp-datastream",
    "name": "Datastream",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/datastream.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-debugger': {
    "id": "gcp-debugger",
    "name": "Debugger",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/debugger.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-developer-portal': {
    "id": "gcp-developer-portal",
    "name": "Developer Portal",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/developer-portal.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-dialogflow-cx': {
    "id": "gcp-dialogflow-cx",
    "name": "Dialogflow Cx",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dialogflow-cx.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-dialogflow-insights': {
    "id": "gcp-dialogflow-insights",
    "name": "Dialogflow Insights",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dialogflow-insights.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-dialogflow': {
    "id": "gcp-dialogflow",
    "name": "Dialogflow",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/dialogflow.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "monitoring"
    ]
  },
  'gcp-document-ai': {
    "id": "gcp-document-ai",
    "name": "Document Ai",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/document-ai.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-early-access-center': {
    "id": "gcp-early-access-center",
    "name": "Early Access Center",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/early-access-center.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-error-reporting': {
    "id": "gcp-error-reporting",
    "name": "Error Reporting",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/error-reporting.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-eventarc': {
    "id": "gcp-eventarc",
    "name": "Eventarc",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/eventarc.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-filestore': {
    "id": "gcp-filestore",
    "name": "Filestore",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/filestore.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-financial-services-marketplace': {
    "id": "gcp-financial-services-marketplace",
    "name": "Financial Services Marketplace",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/financial-services-marketplace.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-firestore': {
    "id": "gcp-firestore",
    "name": "Firestore",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/firestore.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-fleet-engine': {
    "id": "gcp-fleet-engine",
    "name": "Fleet Engine",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/fleet-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-free-trial': {
    "id": "gcp-free-trial",
    "name": "Free Trial",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/free-trial.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-game-servers': {
    "id": "gcp-game-servers",
    "name": "Game Servers",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/game-servers.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-gce-systems-management': {
    "id": "gcp-gce-systems-management",
    "name": "Gce Systems Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/gce-systems-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-genomics': {
    "id": "gcp-genomics",
    "name": "Genomics",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/genomics.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-gke-on-prem': {
    "id": "gcp-gke-on-prem",
    "name": "Gke On Prem",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/gke-on-prem.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-google-cloud-marketplace': {
    "id": "gcp-google-cloud-marketplace",
    "name": "Google Cloud Marketplace",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/google-cloud-marketplace.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-google-kubernetes-engine': {
    "id": "gcp-google-kubernetes-engine",
    "name": "Google Kubernetes Engine",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/google-kubernetes-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "kubernetes"
    ]
  },
  'gcp-google-maps-platform': {
    "id": "gcp-google-maps-platform",
    "name": "Google Maps Platform",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/google-maps-platform.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-healthcare-nlp-api': {
    "id": "gcp-healthcare-nlp-api",
    "name": "Healthcare Nlp Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/healthcare-nlp-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-home': {
    "id": "gcp-home",
    "name": "Home",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/home.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-identity-and-access-management': {
    "id": "gcp-identity-and-access-management",
    "name": "Identity And Access Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/identity-and-access-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-identity-aware-proxy': {
    "id": "gcp-identity-aware-proxy",
    "name": "Identity Aware Proxy",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/identity-aware-proxy.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-identity-platform': {
    "id": "gcp-identity-platform",
    "name": "Identity Platform",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/identity-platform.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-iot-core': {
    "id": "gcp-iot-core",
    "name": "Iot Core",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/iot-core.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-iot-edge': {
    "id": "gcp-iot-edge",
    "name": "Iot Edge",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/iot-edge.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-key-access-justifications': {
    "id": "gcp-key-access-justifications",
    "name": "Key Access Justifications",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/key-access-justifications.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-key-management-service': {
    "id": "gcp-key-management-service",
    "name": "Key Management Service",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/key-management-service.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-kuberun': {
    "id": "gcp-kuberun",
    "name": "Kuberun",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/kuberun.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-launcher': {
    "id": "gcp-launcher",
    "name": "Launcher",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/launcher.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-local-ssd': {
    "id": "gcp-local-ssd",
    "name": "Local Ssd",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/local-ssd.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-looker': {
    "id": "gcp-looker",
    "name": "Looker",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/looker.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-managed-service-for-microsoft-active-directory': {
    "id": "gcp-managed-service-for-microsoft-active-directory",
    "name": "Managed Service For Microsoft Active Directory",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/managed-service-for-microsoft-active-directory.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-media-translation-api': {
    "id": "gcp-media-translation-api",
    "name": "Media Translation Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/media-translation-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-memorystore': {
    "id": "gcp-memorystore",
    "name": "Memorystore",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/memorystore.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-migrate-for-anthos': {
    "id": "gcp-migrate-for-anthos",
    "name": "Migrate For Anthos",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/migrate-for-anthos.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-migrate-for-compute-engine': {
    "id": "gcp-migrate-for-compute-engine",
    "name": "Migrate For Compute Engine",
    "provider": "gcp",
    "category": "compute",
    "path": "/icons/gcp/migrate-for-compute-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "compute",
      "server"
    ]
  },
  'gcp-my-cloud': {
    "id": "gcp-my-cloud",
    "name": "My Cloud",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/my-cloud.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-network-connectivity-center': {
    "id": "gcp-network-connectivity-center",
    "name": "Network Connectivity Center",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/network-connectivity-center.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-network-intelligence-center': {
    "id": "gcp-network-intelligence-center",
    "name": "Network Intelligence Center",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/network-intelligence-center.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-network-security': {
    "id": "gcp-network-security",
    "name": "Network Security",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/network-security.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking",
      "security"
    ]
  },
  'gcp-network-tiers': {
    "id": "gcp-network-tiers",
    "name": "Network Tiers",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/network-tiers.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-network-topology': {
    "id": "gcp-network-topology",
    "name": "Network Topology",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/network-topology.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking",
      "monitoring"
    ]
  },
  'gcp-onboarding': {
    "id": "gcp-onboarding",
    "name": "Onboarding",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/onboarding.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-os-configuration-management': {
    "id": "gcp-os-configuration-management",
    "name": "Os Configuration Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/os-configuration-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-os-inventory-management': {
    "id": "gcp-os-inventory-management",
    "name": "Os Inventory Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/os-inventory-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-os-patch-management': {
    "id": "gcp-os-patch-management",
    "name": "Os Patch Management",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/os-patch-management.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-partner-interconnect': {
    "id": "gcp-partner-interconnect",
    "name": "Partner Interconnect",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/partner-interconnect.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-partner-portal': {
    "id": "gcp-partner-portal",
    "name": "Partner Portal",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/partner-portal.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-performance-dashboard': {
    "id": "gcp-performance-dashboard",
    "name": "Performance Dashboard",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/performance-dashboard.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-permissions': {
    "id": "gcp-permissions",
    "name": "Permissions",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/permissions.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-persistent-disk': {
    "id": "gcp-persistent-disk",
    "name": "Persistent Disk",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/persistent-disk.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-phishing-protection': {
    "id": "gcp-phishing-protection",
    "name": "Phishing Protection",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/phishing-protection.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-policy-analyzer': {
    "id": "gcp-policy-analyzer",
    "name": "Policy Analyzer",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/policy-analyzer.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-premium-network-tier': {
    "id": "gcp-premium-network-tier",
    "name": "Premium Network Tier",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/premium-network-tier.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-private-connectivity': {
    "id": "gcp-private-connectivity",
    "name": "Private Connectivity",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/private-connectivity.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-private-service-connect': {
    "id": "gcp-private-service-connect",
    "name": "Private Service Connect",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/private-service-connect.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-producer-portal': {
    "id": "gcp-producer-portal",
    "name": "Producer Portal",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/producer-portal.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-profiler': {
    "id": "gcp-profiler",
    "name": "Profiler",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/profiler.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-project': {
    "id": "gcp-project",
    "name": "Project",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/project.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-pubsub': {
    "id": "gcp-pubsub",
    "name": "Pubsub",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/pubsub.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-quantum-engine': {
    "id": "gcp-quantum-engine",
    "name": "Quantum Engine",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/quantum-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-quotas': {
    "id": "gcp-quotas",
    "name": "Quotas",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/quotas.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-real-world-insights': {
    "id": "gcp-real-world-insights",
    "name": "Real World Insights",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/real-world-insights.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-recommendations-ai': {
    "id": "gcp-recommendations-ai",
    "name": "Recommendations Ai",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/recommendations-ai.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-release-notes': {
    "id": "gcp-release-notes",
    "name": "Release Notes",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/release-notes.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-retail-api': {
    "id": "gcp-retail-api",
    "name": "Retail Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/retail-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-risk-manager': {
    "id": "gcp-risk-manager",
    "name": "Risk Manager",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/risk-manager.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-runtime-config': {
    "id": "gcp-runtime-config",
    "name": "Runtime Config",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/runtime-config.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-secret-manager': {
    "id": "gcp-secret-manager",
    "name": "Secret Manager",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/secret-manager.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-security-command-center': {
    "id": "gcp-security-command-center",
    "name": "Security Command Center",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/security-command-center.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-security-health-advisor': {
    "id": "gcp-security-health-advisor",
    "name": "Security Health Advisor",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/security-health-advisor.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-security-key-enforcement': {
    "id": "gcp-security-key-enforcement",
    "name": "Security Key Enforcement",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/security-key-enforcement.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-security': {
    "id": "gcp-security",
    "name": "Security",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/security.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-service-discovery': {
    "id": "gcp-service-discovery",
    "name": "Service Discovery",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/service-discovery.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-speech-to-text': {
    "id": "gcp-speech-to-text",
    "name": "Speech To Text",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/speech-to-text.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-stackdriver': {
    "id": "gcp-stackdriver",
    "name": "Stackdriver",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/stackdriver.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-standard-network-tier': {
    "id": "gcp-standard-network-tier",
    "name": "Standard Network Tier",
    "provider": "gcp",
    "category": "networking",
    "path": "/icons/gcp/standard-network-tier.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "networking"
    ]
  },
  'gcp-stream-suite': {
    "id": "gcp-stream-suite",
    "name": "Stream Suite",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/stream-suite.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-support': {
    "id": "gcp-support",
    "name": "Support",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/support.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-tensorflow-enterprise': {
    "id": "gcp-tensorflow-enterprise",
    "name": "Tensorflow Enterprise",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/tensorflow-enterprise.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-text-to-speech': {
    "id": "gcp-text-to-speech",
    "name": "Text To Speech",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/text-to-speech.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-tools-for-powershell': {
    "id": "gcp-tools-for-powershell",
    "name": "Tools For Powershell",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/tools-for-powershell.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-trace': {
    "id": "gcp-trace",
    "name": "Trace",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/trace.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-traffic-director': {
    "id": "gcp-traffic-director",
    "name": "Traffic Director",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/traffic-director.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-transfer-appliance': {
    "id": "gcp-transfer-appliance",
    "name": "Transfer Appliance",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/transfer-appliance.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-transfer': {
    "id": "gcp-transfer",
    "name": "Transfer",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/transfer.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-user-preferences': {
    "id": "gcp-user-preferences",
    "name": "User Preferences",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/user-preferences.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-vertexai': {
    "id": "gcp-vertexai",
    "name": "Vertexai",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/vertexai.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-video-intelligence-api': {
    "id": "gcp-video-intelligence-api",
    "name": "Video Intelligence Api",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/video-intelligence-api.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "api"
    ]
  },
  'gcp-virtual-private-cloud': {
    "id": "gcp-virtual-private-cloud",
    "name": "Virtual Private Cloud",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/virtual-private-cloud.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-visual-inspection': {
    "id": "gcp-visual-inspection",
    "name": "Visual Inspection",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/visual-inspection.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-vmware-engine': {
    "id": "gcp-vmware-engine",
    "name": "Vmware Engine",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/vmware-engine.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "compute",
      "server"
    ]
  },
  'gcp-web-risk': {
    "id": "gcp-web-risk",
    "name": "Web Risk",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/web-risk.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-web-security-scanner': {
    "id": "gcp-web-security-scanner",
    "name": "Web Security Scanner",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/web-security-scanner.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "security"
    ]
  },
  'gcp-workflows': {
    "id": "gcp-workflows",
    "name": "Workflows",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/workflows.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "service"
    ]
  },
  'gcp-workload-identity-pool': {
    "id": "gcp-workload-identity-pool",
    "name": "Workload Identity Pool",
    "provider": "gcp",
    "category": "service",
    "path": "/icons/gcp/workload-identity-pool.svg",
    "format": "svg",
    "tags": [
      "gcp",
      "load-balancer"
    ]
  },

  // Kubernetes (46 icons)
  'k8s-api': {
    "id": "k8s-api",
    "name": "Api",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/api.png",
    "format": "png",
    "tags": [
      "k8s",
      "api"
    ]
  },
  'k8s-c-c-m': {
    "id": "k8s-c-c-m",
    "name": "C C M",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/c-c-m.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-c-m': {
    "id": "k8s-c-m",
    "name": "C M",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/c-m.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-c-role': {
    "id": "k8s-c-role",
    "name": "C Role",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/c-role.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-chaos-mesh': {
    "id": "k8s-chaos-mesh",
    "name": "Chaos Mesh",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/chaos-mesh.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  // ... 41 more k8s icons
  'k8s-cm': {
    "id": "k8s-cm",
    "name": "Cm",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/cm.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-crb': {
    "id": "k8s-crb",
    "name": "Crb",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/crb.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-crd': {
    "id": "k8s-crd",
    "name": "Crd",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/crd.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-cronjob': {
    "id": "k8s-cronjob",
    "name": "Cronjob",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/cronjob.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-deploy': {
    "id": "k8s-deploy",
    "name": "Deploy",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/deploy.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-ds': {
    "id": "k8s-ds",
    "name": "Ds",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/ds.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-ep': {
    "id": "k8s-ep",
    "name": "Ep",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/ep.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-etcd': {
    "id": "k8s-etcd",
    "name": "Etcd",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/etcd.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-external-dns': {
    "id": "k8s-external-dns",
    "name": "External Dns",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/external-dns.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-group': {
    "id": "k8s-group",
    "name": "Group",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/group.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-helm': {
    "id": "k8s-helm",
    "name": "Helm",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/helm.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-hpa': {
    "id": "k8s-hpa",
    "name": "Hpa",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/hpa.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-ing': {
    "id": "k8s-ing",
    "name": "Ing",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/ing.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-job': {
    "id": "k8s-job",
    "name": "Job",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/job.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-k-proxy': {
    "id": "k8s-k-proxy",
    "name": "K Proxy",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/k-proxy.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-k8s': {
    "id": "k8s-k8s",
    "name": "K8s",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/k8s.png",
    "format": "png",
    "tags": [
      "k8s",
      "kubernetes"
    ]
  },
  'k8s-krew': {
    "id": "k8s-krew",
    "name": "Krew",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/krew.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-kubelet': {
    "id": "k8s-kubelet",
    "name": "Kubelet",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/kubelet.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-kustomize': {
    "id": "k8s-kustomize",
    "name": "Kustomize",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/kustomize.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-limits': {
    "id": "k8s-limits",
    "name": "Limits",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/limits.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-litmus-chaos': {
    "id": "k8s-litmus-chaos",
    "name": "Litmus Chaos",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/litmus-chaos.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-master': {
    "id": "k8s-master",
    "name": "Master",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/master.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-netpol': {
    "id": "k8s-netpol",
    "name": "Netpol",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/netpol.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-node': {
    "id": "k8s-node",
    "name": "Node",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/node.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-ns': {
    "id": "k8s-ns",
    "name": "Ns",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/ns.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-pod': {
    "id": "k8s-pod",
    "name": "Pod",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/pod.png",
    "format": "png",
    "tags": [
      "k8s",
      "kubernetes"
    ]
  },
  'k8s-psp': {
    "id": "k8s-psp",
    "name": "Psp",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/psp.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-pv': {
    "id": "k8s-pv",
    "name": "Pv",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/pv.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-pvc': {
    "id": "k8s-pvc",
    "name": "Pvc",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/pvc.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-quota': {
    "id": "k8s-quota",
    "name": "Quota",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/quota.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-rb': {
    "id": "k8s-rb",
    "name": "Rb",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/rb.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-role': {
    "id": "k8s-role",
    "name": "Role",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/role.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-rs': {
    "id": "k8s-rs",
    "name": "Rs",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/rs.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-sa': {
    "id": "k8s-sa",
    "name": "Sa",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/sa.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-sc': {
    "id": "k8s-sc",
    "name": "Sc",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/sc.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-sched': {
    "id": "k8s-sched",
    "name": "Sched",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/sched.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-secret': {
    "id": "k8s-secret",
    "name": "Secret",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/secret.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-sts': {
    "id": "k8s-sts",
    "name": "Sts",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/sts.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-svc': {
    "id": "k8s-svc",
    "name": "Svc",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/svc.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-user': {
    "id": "k8s-user",
    "name": "User",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/user.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },
  'k8s-vol': {
    "id": "k8s-vol",
    "name": "Vol",
    "provider": "k8s",
    "category": "service",
    "path": "/icons/k8s/vol.png",
    "format": "png",
    "tags": [
      "k8s",
      "service"
    ]
  },

  // Programming (74 icons)
  'programming-action': {
    "id": "programming-action",
    "name": "Action",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/action.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-angular': {
    "id": "programming-angular",
    "name": "Angular",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/angular.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-backbone': {
    "id": "programming-backbone",
    "name": "Backbone",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/backbone.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-bash': {
    "id": "programming-bash",
    "name": "Bash",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/bash.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-c': {
    "id": "programming-c",
    "name": "C",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/c.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  // ... 69 more programming icons
  'programming-camel': {
    "id": "programming-camel",
    "name": "Camel",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/camel.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-collate': {
    "id": "programming-collate",
    "name": "Collate",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/collate.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-cpp': {
    "id": "programming-cpp",
    "name": "Cpp",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/cpp.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-csharp': {
    "id": "programming-csharp",
    "name": "Csharp",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/csharp.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-dapr': {
    "id": "programming-dapr",
    "name": "Dapr",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/dapr.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-dart': {
    "id": "programming-dart",
    "name": "Dart",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/dart.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-database': {
    "id": "programming-database",
    "name": "Database",
    "provider": "programming",
    "category": "database",
    "path": "/icons/programming/database.png",
    "format": "png",
    "tags": [
      "programming",
      "database"
    ]
  },
  'programming-decision': {
    "id": "programming-decision",
    "name": "Decision",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/decision.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-delay': {
    "id": "programming-delay",
    "name": "Delay",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/delay.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-display': {
    "id": "programming-display",
    "name": "Display",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/display.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-django': {
    "id": "programming-django",
    "name": "Django",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/django.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-document': {
    "id": "programming-document",
    "name": "Document",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/document.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-dotnet': {
    "id": "programming-dotnet",
    "name": "Dotnet",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/dotnet.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-elixir': {
    "id": "programming-elixir",
    "name": "Elixir",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/elixir.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-ember': {
    "id": "programming-ember",
    "name": "Ember",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/ember.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-erlang': {
    "id": "programming-erlang",
    "name": "Erlang",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/erlang.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-fastapi': {
    "id": "programming-fastapi",
    "name": "Fastapi",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/fastapi.png",
    "format": "png",
    "tags": [
      "programming",
      "api"
    ]
  },
  'programming-flask': {
    "id": "programming-flask",
    "name": "Flask",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/flask.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-flutter': {
    "id": "programming-flutter",
    "name": "Flutter",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/flutter.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-go': {
    "id": "programming-go",
    "name": "Go",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/go.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-graphql': {
    "id": "programming-graphql",
    "name": "Graphql",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/graphql.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-hibernate': {
    "id": "programming-hibernate",
    "name": "Hibernate",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/hibernate.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-input-output': {
    "id": "programming-input-output",
    "name": "Input Output",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/input-output.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-inspection': {
    "id": "programming-inspection",
    "name": "Inspection",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/inspection.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-internal-storage': {
    "id": "programming-internal-storage",
    "name": "Internal Storage",
    "provider": "programming",
    "category": "storage",
    "path": "/icons/programming/internal-storage.png",
    "format": "png",
    "tags": [
      "programming",
      "storage"
    ]
  },
  'programming-java': {
    "id": "programming-java",
    "name": "Java",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/java.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-javascript': {
    "id": "programming-javascript",
    "name": "Javascript",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/javascript.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-jhipster': {
    "id": "programming-jhipster",
    "name": "Jhipster",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/jhipster.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-kotlin': {
    "id": "programming-kotlin",
    "name": "Kotlin",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/kotlin.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-laravel': {
    "id": "programming-laravel",
    "name": "Laravel",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/laravel.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-latex': {
    "id": "programming-latex",
    "name": "Latex",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/latex.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-loop-limit': {
    "id": "programming-loop-limit",
    "name": "Loop Limit",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/loop-limit.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-manual-input': {
    "id": "programming-manual-input",
    "name": "Manual Input",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/manual-input.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-manual-loop': {
    "id": "programming-manual-loop",
    "name": "Manual Loop",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/manual-loop.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-matlab': {
    "id": "programming-matlab",
    "name": "Matlab",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/matlab.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-merge': {
    "id": "programming-merge",
    "name": "Merge",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/merge.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-micronaut': {
    "id": "programming-micronaut",
    "name": "Micronaut",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/micronaut.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-multiple-documents': {
    "id": "programming-multiple-documents",
    "name": "Multiple Documents",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/multiple-documents.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-nextjs': {
    "id": "programming-nextjs",
    "name": "Nextjs",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/nextjs.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-nodejs': {
    "id": "programming-nodejs",
    "name": "Nodejs",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/nodejs.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-off-page-connector-left': {
    "id": "programming-off-page-connector-left",
    "name": "Off Page Connector Left",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/off-page-connector-left.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-off-page-connector-right': {
    "id": "programming-off-page-connector-right",
    "name": "Off Page Connector Right",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/off-page-connector-right.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-or': {
    "id": "programming-or",
    "name": "Or",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/or.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-phoenix': {
    "id": "programming-phoenix",
    "name": "Phoenix",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/phoenix.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-php': {
    "id": "programming-php",
    "name": "Php",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/php.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-predefined-process': {
    "id": "programming-predefined-process",
    "name": "Predefined Process",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/predefined-process.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-preparation': {
    "id": "programming-preparation",
    "name": "Preparation",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/preparation.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-programming': {
    "id": "programming-programming",
    "name": "Programming",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/programming.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-python': {
    "id": "programming-python",
    "name": "Python",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/python.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-quarkus': {
    "id": "programming-quarkus",
    "name": "Quarkus",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/quarkus.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-r': {
    "id": "programming-r",
    "name": "R",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/r.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-rails': {
    "id": "programming-rails",
    "name": "Rails",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/rails.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-react': {
    "id": "programming-react",
    "name": "React",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/react.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-ruby': {
    "id": "programming-ruby",
    "name": "Ruby",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/ruby.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-rust': {
    "id": "programming-rust",
    "name": "Rust",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/rust.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-scala': {
    "id": "programming-scala",
    "name": "Scala",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/scala.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-sort': {
    "id": "programming-sort",
    "name": "Sort",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/sort.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-spring': {
    "id": "programming-spring",
    "name": "Spring",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/spring.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-sql': {
    "id": "programming-sql",
    "name": "Sql",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/sql.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-sqlpage': {
    "id": "programming-sqlpage",
    "name": "Sqlpage",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/sqlpage.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-starlette': {
    "id": "programming-starlette",
    "name": "Starlette",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/starlette.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-start-end': {
    "id": "programming-start-end",
    "name": "Start End",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/start-end.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-stored-data': {
    "id": "programming-stored-data",
    "name": "Stored Data",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/stored-data.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-summing-junction': {
    "id": "programming-summing-junction",
    "name": "Summing Junction",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/summing-junction.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-svelte': {
    "id": "programming-svelte",
    "name": "Svelte",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/svelte.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-swift': {
    "id": "programming-swift",
    "name": "Swift",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/swift.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-typescript': {
    "id": "programming-typescript",
    "name": "Typescript",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/typescript.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-vercel': {
    "id": "programming-vercel",
    "name": "Vercel",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/vercel.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },
  'programming-vue': {
    "id": "programming-vue",
    "name": "Vue",
    "provider": "programming",
    "category": "service",
    "path": "/icons/programming/vue.png",
    "format": "png",
    "tags": [
      "programming",
      "service"
    ]
  },

  // Generic (27 icons)
  'generic-android': {
    "id": "generic-android",
    "name": "Android",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/android.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-blank': {
    "id": "generic-blank",
    "name": "Blank",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/blank.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-centos': {
    "id": "generic-centos",
    "name": "Centos",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/centos.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-datacenter': {
    "id": "generic-datacenter",
    "name": "Datacenter",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/datacenter.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-debian': {
    "id": "generic-debian",
    "name": "Debian",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/debian.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  // ... 22 more generic icons
  'generic-firewall': {
    "id": "generic-firewall",
    "name": "Firewall",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/firewall.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-generic': {
    "id": "generic-generic",
    "name": "Generic",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/generic.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-ios': {
    "id": "generic-ios",
    "name": "Ios",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/ios.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-linux-general': {
    "id": "generic-linux-general",
    "name": "Linux General",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/linux-general.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-mobile': {
    "id": "generic-mobile",
    "name": "Mobile",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/mobile.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-qemu': {
    "id": "generic-qemu",
    "name": "Qemu",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/qemu.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-rack': {
    "id": "generic-rack",
    "name": "Rack",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/rack.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-raspbian': {
    "id": "generic-raspbian",
    "name": "Raspbian",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/raspbian.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-red-hat': {
    "id": "generic-red-hat",
    "name": "Red Hat",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/red-hat.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-router': {
    "id": "generic-router",
    "name": "Router",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/router.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-sql': {
    "id": "generic-sql",
    "name": "Sql",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/sql.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-storage': {
    "id": "generic-storage",
    "name": "Storage",
    "provider": "generic",
    "category": "storage",
    "path": "/icons/generic/storage.png",
    "format": "png",
    "tags": [
      "generic",
      "storage"
    ]
  },
  'generic-subnet': {
    "id": "generic-subnet",
    "name": "Subnet",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/subnet.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-suse': {
    "id": "generic-suse",
    "name": "Suse",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/suse.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-switch': {
    "id": "generic-switch",
    "name": "Switch",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/switch.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-tablet': {
    "id": "generic-tablet",
    "name": "Tablet",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/tablet.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-ubuntu': {
    "id": "generic-ubuntu",
    "name": "Ubuntu",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/ubuntu.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-virtualbox': {
    "id": "generic-virtualbox",
    "name": "Virtualbox",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/virtualbox.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-vmware': {
    "id": "generic-vmware",
    "name": "Vmware",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/vmware.png",
    "format": "png",
    "tags": [
      "generic",
      "compute",
      "server"
    ]
  },
  'generic-vpn': {
    "id": "generic-vpn",
    "name": "Vpn",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/vpn.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-windows': {
    "id": "generic-windows",
    "name": "Windows",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/windows.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },
  'generic-xen': {
    "id": "generic-xen",
    "name": "Xen",
    "provider": "generic",
    "category": "service",
    "path": "/icons/generic/xen.png",
    "format": "png",
    "tags": [
      "generic",
      "service"
    ]
  },

  // On-Premises (173 icons)
  'onprem-activemq': {
    "id": "onprem-activemq",
    "name": "Activemq",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/activemq.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-aerospike': {
    "id": "onprem-aerospike",
    "name": "Aerospike",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/aerospike.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-airflow': {
    "id": "onprem-airflow",
    "name": "Airflow",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/airflow.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-ambassador': {
    "id": "onprem-ambassador",
    "name": "Ambassador",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/ambassador.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-ansible': {
    "id": "onprem-ansible",
    "name": "Ansible",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/ansible.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  // ... 168 more onprem icons
  'onprem-apache': {
    "id": "onprem-apache",
    "name": "Apache",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/apache.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-argocd': {
    "id": "onprem-argocd",
    "name": "Argocd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/argocd.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-atlantis': {
    "id": "onprem-atlantis",
    "name": "Atlantis",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/atlantis.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-awx': {
    "id": "onprem-awx",
    "name": "Awx",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/awx.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-beam': {
    "id": "onprem-beam",
    "name": "Beam",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/beam.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-bind-9': {
    "id": "onprem-bind-9",
    "name": "Bind 9",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/bind-9.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-bitwarden': {
    "id": "onprem-bitwarden",
    "name": "Bitwarden",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/bitwarden.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-boundary': {
    "id": "onprem-boundary",
    "name": "Boundary",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/boundary.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-buzzfeed-sso': {
    "id": "onprem-buzzfeed-sso",
    "name": "Buzzfeed Sso",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/buzzfeed-sso.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-caddy': {
    "id": "onprem-caddy",
    "name": "Caddy",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/caddy.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cassandra': {
    "id": "onprem-cassandra",
    "name": "Cassandra",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cassandra.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-celery': {
    "id": "onprem-celery",
    "name": "Celery",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/celery.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-centrifugo': {
    "id": "onprem-centrifugo",
    "name": "Centrifugo",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/centrifugo.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-ceph-osd': {
    "id": "onprem-ceph-osd",
    "name": "Ceph Osd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/ceph-osd.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-ceph': {
    "id": "onprem-ceph",
    "name": "Ceph",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/ceph.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cert-manager': {
    "id": "onprem-cert-manager",
    "name": "Cert Manager",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cert-manager.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-circleci': {
    "id": "onprem-circleci",
    "name": "Circleci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/circleci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cisco-router': {
    "id": "onprem-cisco-router",
    "name": "Cisco Router",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cisco-router.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cisco-switch-l2': {
    "id": "onprem-cisco-switch-l2",
    "name": "Cisco Switch L2",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cisco-switch-l2.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cisco-switch-l3': {
    "id": "onprem-cisco-switch-l3",
    "name": "Cisco Switch L3",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cisco-switch-l3.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-clickhouse': {
    "id": "onprem-clickhouse",
    "name": "Clickhouse",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/clickhouse.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-client': {
    "id": "onprem-client",
    "name": "Client",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/client.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cockroachdb': {
    "id": "onprem-cockroachdb",
    "name": "Cockroachdb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cockroachdb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-concourseci': {
    "id": "onprem-concourseci",
    "name": "Concourseci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/concourseci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-consul': {
    "id": "onprem-consul",
    "name": "Consul",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/consul.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-containerd': {
    "id": "onprem-containerd",
    "name": "Containerd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/containerd.png",
    "format": "png",
    "tags": [
      "onprem",
      "container"
    ]
  },
  'onprem-coredns': {
    "id": "onprem-coredns",
    "name": "Coredns",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/coredns.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-cortex': {
    "id": "onprem-cortex",
    "name": "Cortex",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/cortex.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-couchbase': {
    "id": "onprem-couchbase",
    "name": "Couchbase",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/couchbase.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-couchdb': {
    "id": "onprem-couchdb",
    "name": "Couchdb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/couchdb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-crio': {
    "id": "onprem-crio",
    "name": "Crio",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/crio.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-databricks': {
    "id": "onprem-databricks",
    "name": "Databricks",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/databricks.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-datadog': {
    "id": "onprem-datadog",
    "name": "Datadog",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/datadog.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-dbt': {
    "id": "onprem-dbt",
    "name": "Dbt",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/dbt.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-dex': {
    "id": "onprem-dex",
    "name": "Dex",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/dex.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-dgraph': {
    "id": "onprem-dgraph",
    "name": "Dgraph",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/dgraph.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-digdag': {
    "id": "onprem-digdag",
    "name": "Digdag",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/digdag.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-docker': {
    "id": "onprem-docker",
    "name": "Docker",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/docker.png",
    "format": "png",
    "tags": [
      "onprem",
      "container"
    ]
  },
  'onprem-dremio': {
    "id": "onprem-dremio",
    "name": "Dremio",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/dremio.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-droneci': {
    "id": "onprem-droneci",
    "name": "Droneci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/droneci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-druid': {
    "id": "onprem-druid",
    "name": "Druid",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/druid.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-duckdb': {
    "id": "onprem-duckdb",
    "name": "Duckdb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/duckdb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-dynatrace': {
    "id": "onprem-dynatrace",
    "name": "Dynatrace",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/dynatrace.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-embulk': {
    "id": "onprem-embulk",
    "name": "Embulk",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/embulk.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-emqx': {
    "id": "onprem-emqx",
    "name": "Emqx",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/emqx.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-envoy': {
    "id": "onprem-envoy",
    "name": "Envoy",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/envoy.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-etcd': {
    "id": "onprem-etcd",
    "name": "Etcd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/etcd.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-firecracker': {
    "id": "onprem-firecracker",
    "name": "Firecracker",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/firecracker.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-flagger': {
    "id": "onprem-flagger",
    "name": "Flagger",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/flagger.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-flink': {
    "id": "onprem-flink",
    "name": "Flink",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/flink.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-fluentbit': {
    "id": "onprem-fluentbit",
    "name": "Fluentbit",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/fluentbit.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-fluentd': {
    "id": "onprem-fluentd",
    "name": "Fluentd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/fluentd.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-flux': {
    "id": "onprem-flux",
    "name": "Flux",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/flux.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-git': {
    "id": "onprem-git",
    "name": "Git",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/git.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-gitea': {
    "id": "onprem-gitea",
    "name": "Gitea",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/gitea.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-github-actions': {
    "id": "onprem-github-actions",
    "name": "Github Actions",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/github-actions.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-github': {
    "id": "onprem-github",
    "name": "Github",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/github.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-gitlab': {
    "id": "onprem-gitlab",
    "name": "Gitlab",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/gitlab.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-gitlabci': {
    "id": "onprem-gitlabci",
    "name": "Gitlabci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/gitlabci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-glassfish': {
    "id": "onprem-glassfish",
    "name": "Glassfish",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/glassfish.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-glusterfs': {
    "id": "onprem-glusterfs",
    "name": "Glusterfs",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/glusterfs.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-grafana': {
    "id": "onprem-grafana",
    "name": "Grafana",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/grafana.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-graylog': {
    "id": "onprem-graylog",
    "name": "Graylog",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/graylog.png",
    "format": "png",
    "tags": [
      "onprem",
      "monitoring"
    ]
  },
  'onprem-gunicorn': {
    "id": "onprem-gunicorn",
    "name": "Gunicorn",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/gunicorn.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-gvisor': {
    "id": "onprem-gvisor",
    "name": "Gvisor",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/gvisor.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-hadoop': {
    "id": "onprem-hadoop",
    "name": "Hadoop",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/hadoop.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-haproxy': {
    "id": "onprem-haproxy",
    "name": "Haproxy",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/haproxy.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-harbor': {
    "id": "onprem-harbor",
    "name": "Harbor",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/harbor.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-hazelcast': {
    "id": "onprem-hazelcast",
    "name": "Hazelcast",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/hazelcast.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-hbase': {
    "id": "onprem-hbase",
    "name": "Hbase",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/hbase.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-hive': {
    "id": "onprem-hive",
    "name": "Hive",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/hive.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-humio': {
    "id": "onprem-humio",
    "name": "Humio",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/humio.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-influxdb': {
    "id": "onprem-influxdb",
    "name": "Influxdb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/influxdb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-internet': {
    "id": "onprem-internet",
    "name": "Internet",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/internet.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-istio': {
    "id": "onprem-istio",
    "name": "Istio",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/istio.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-jaeger': {
    "id": "onprem-jaeger",
    "name": "Jaeger",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/jaeger.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-janusgraph': {
    "id": "onprem-janusgraph",
    "name": "Janusgraph",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/janusgraph.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-jbossas': {
    "id": "onprem-jbossas",
    "name": "Jbossas",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/jbossas.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-jenkins': {
    "id": "onprem-jenkins",
    "name": "Jenkins",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/jenkins.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-jetty': {
    "id": "onprem-jetty",
    "name": "Jetty",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/jetty.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-jfrog': {
    "id": "onprem-jfrog",
    "name": "Jfrog",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/jfrog.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-k3s': {
    "id": "onprem-k3s",
    "name": "K3s",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/k3s.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-kafka': {
    "id": "onprem-kafka",
    "name": "Kafka",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/kafka.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-kong': {
    "id": "onprem-kong",
    "name": "Kong",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/kong.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-kubeflow': {
    "id": "onprem-kubeflow",
    "name": "Kubeflow",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/kubeflow.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-lets-encrypt': {
    "id": "onprem-lets-encrypt",
    "name": "Lets Encrypt",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/lets-encrypt.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-linkerd': {
    "id": "onprem-linkerd",
    "name": "Linkerd",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/linkerd.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-loki': {
    "id": "onprem-loki",
    "name": "Loki",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/loki.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-lxc': {
    "id": "onprem-lxc",
    "name": "Lxc",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/lxc.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mariadb': {
    "id": "onprem-mariadb",
    "name": "Mariadb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mariadb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-memcached': {
    "id": "onprem-memcached",
    "name": "Memcached",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/memcached.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-metabase': {
    "id": "onprem-metabase",
    "name": "Metabase",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/metabase.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mikrotik': {
    "id": "onprem-mikrotik",
    "name": "Mikrotik",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mikrotik.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mimir': {
    "id": "onprem-mimir",
    "name": "Mimir",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mimir.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mlflow': {
    "id": "onprem-mlflow",
    "name": "Mlflow",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mlflow.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mongodb': {
    "id": "onprem-mongodb",
    "name": "Mongodb",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mongodb.png",
    "format": "png",
    "tags": [
      "onprem",
      "database"
    ]
  },
  'onprem-mssql': {
    "id": "onprem-mssql",
    "name": "Mssql",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mssql.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-mysql': {
    "id": "onprem-mysql",
    "name": "Mysql",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/mysql.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nagios': {
    "id": "onprem-nagios",
    "name": "Nagios",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nagios.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nats': {
    "id": "onprem-nats",
    "name": "Nats",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nats.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-neo4j': {
    "id": "onprem-neo4j",
    "name": "Neo4j",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/neo4j.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-newrelic': {
    "id": "onprem-newrelic",
    "name": "Newrelic",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/newrelic.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nextcloud': {
    "id": "onprem-nextcloud",
    "name": "Nextcloud",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nextcloud.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nginx': {
    "id": "onprem-nginx",
    "name": "Nginx",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nginx.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nifi': {
    "id": "onprem-nifi",
    "name": "Nifi",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nifi.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-nomad': {
    "id": "onprem-nomad",
    "name": "Nomad",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/nomad.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-norikra': {
    "id": "onprem-norikra",
    "name": "Norikra",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/norikra.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-oauth2-proxy': {
    "id": "onprem-oauth2-proxy",
    "name": "Oauth2 Proxy",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/oauth2-proxy.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-ocelot': {
    "id": "onprem-ocelot",
    "name": "Ocelot",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/ocelot.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-onprem': {
    "id": "onprem-onprem",
    "name": "Onprem",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/onprem.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-open-service-mesh': {
    "id": "onprem-open-service-mesh",
    "name": "Open Service Mesh",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/open-service-mesh.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-opnsense': {
    "id": "onprem-opnsense",
    "name": "Opnsense",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/opnsense.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-oracle': {
    "id": "onprem-oracle",
    "name": "Oracle",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/oracle.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-pfsense': {
    "id": "onprem-pfsense",
    "name": "Pfsense",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/pfsense.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-polyaxon': {
    "id": "onprem-polyaxon",
    "name": "Polyaxon",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/polyaxon.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-pomerium': {
    "id": "onprem-pomerium",
    "name": "Pomerium",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/pomerium.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-portworx': {
    "id": "onprem-portworx",
    "name": "Portworx",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/portworx.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-postgresql': {
    "id": "onprem-postgresql",
    "name": "Postgresql",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/postgresql.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-powerbi': {
    "id": "onprem-powerbi",
    "name": "Powerbi",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/powerbi.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-powerdns-2': {
    "id": "onprem-powerdns-2",
    "name": "Powerdns 2",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/powerdns-2.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-powerdns': {
    "id": "onprem-powerdns",
    "name": "Powerdns",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/powerdns.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-presto': {
    "id": "onprem-presto",
    "name": "Presto",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/presto.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-prometheus-operator': {
    "id": "onprem-prometheus-operator",
    "name": "Prometheus Operator",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/prometheus-operator.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-prometheus': {
    "id": "onprem-prometheus",
    "name": "Prometheus",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/prometheus.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-pulumi': {
    "id": "onprem-pulumi",
    "name": "Pulumi",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/pulumi.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-puppet': {
    "id": "onprem-puppet",
    "name": "Puppet",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/puppet.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-pve': {
    "id": "onprem-pve",
    "name": "Pve",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/pve.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-qdrant': {
    "id": "onprem-qdrant",
    "name": "Qdrant",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/qdrant.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-rabbitmq': {
    "id": "onprem-rabbitmq",
    "name": "Rabbitmq",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/rabbitmq.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-redis': {
    "id": "onprem-redis",
    "name": "Redis",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/redis.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-rkt': {
    "id": "onprem-rkt",
    "name": "Rkt",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/rkt.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-rsyslog': {
    "id": "onprem-rsyslog",
    "name": "Rsyslog",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/rsyslog.png",
    "format": "png",
    "tags": [
      "onprem",
      "monitoring"
    ]
  },
  'onprem-scylla': {
    "id": "onprem-scylla",
    "name": "Scylla",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/scylla.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-sentry': {
    "id": "onprem-sentry",
    "name": "Sentry",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/sentry.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-server': {
    "id": "onprem-server",
    "name": "Server",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/server.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-singer': {
    "id": "onprem-singer",
    "name": "Singer",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/singer.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-solr': {
    "id": "onprem-solr",
    "name": "Solr",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/solr.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-spark': {
    "id": "onprem-spark",
    "name": "Spark",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/spark.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-spinnaker': {
    "id": "onprem-spinnaker",
    "name": "Spinnaker",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/spinnaker.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-splunk': {
    "id": "onprem-splunk",
    "name": "Splunk",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/splunk.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-storm': {
    "id": "onprem-storm",
    "name": "Storm",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/storm.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-superset': {
    "id": "onprem-superset",
    "name": "Superset",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/superset.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-svn': {
    "id": "onprem-svn",
    "name": "Svn",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/svn.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-syslog-ng': {
    "id": "onprem-syslog-ng",
    "name": "Syslog Ng",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/syslog-ng.png",
    "format": "png",
    "tags": [
      "onprem",
      "monitoring"
    ]
  },
  'onprem-tableau': {
    "id": "onprem-tableau",
    "name": "Tableau",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tableau.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-teamcity': {
    "id": "onprem-teamcity",
    "name": "Teamcity",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/teamcity.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-tekton-cli': {
    "id": "onprem-tekton-cli",
    "name": "Tekton Cli",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tekton-cli.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-tekton': {
    "id": "onprem-tekton",
    "name": "Tekton",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tekton.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-tempo': {
    "id": "onprem-tempo",
    "name": "Tempo",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tempo.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-terraform': {
    "id": "onprem-terraform",
    "name": "Terraform",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/terraform.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-thanos': {
    "id": "onprem-thanos",
    "name": "Thanos",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/thanos.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-tomcat': {
    "id": "onprem-tomcat",
    "name": "Tomcat",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tomcat.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-traefik': {
    "id": "onprem-traefik",
    "name": "Traefik",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/traefik.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-travisci': {
    "id": "onprem-travisci",
    "name": "Travisci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/travisci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-trino': {
    "id": "onprem-trino",
    "name": "Trino",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/trino.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-trivy': {
    "id": "onprem-trivy",
    "name": "Trivy",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/trivy.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-tyk': {
    "id": "onprem-tyk",
    "name": "Tyk",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/tyk.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-user': {
    "id": "onprem-user",
    "name": "User",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/user.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-users': {
    "id": "onprem-users",
    "name": "Users",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/users.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-vault': {
    "id": "onprem-vault",
    "name": "Vault",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/vault.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-vector': {
    "id": "onprem-vector",
    "name": "Vector",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/vector.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-vyos': {
    "id": "onprem-vyos",
    "name": "Vyos",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/vyos.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-wildfly': {
    "id": "onprem-wildfly",
    "name": "Wildfly",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/wildfly.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-yarp': {
    "id": "onprem-yarp",
    "name": "Yarp",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/yarp.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-zabbix': {
    "id": "onprem-zabbix",
    "name": "Zabbix",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/zabbix.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-zeromq': {
    "id": "onprem-zeromq",
    "name": "Zeromq",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/zeromq.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-zookeeper': {
    "id": "onprem-zookeeper",
    "name": "Zookeeper",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/zookeeper.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },
  'onprem-zuulci': {
    "id": "onprem-zuulci",
    "name": "Zuulci",
    "provider": "onprem",
    "category": "service",
    "path": "/icons/onprem/zuulci.png",
    "format": "png",
    "tags": [
      "onprem",
      "service"
    ]
  },

} as const;

// ============================================================================
// Helper Functions
// ============================================================================

/**
 * Get icon by ID
 */
export function getIcon(iconId: string): IconDefinition | undefined {
  return ICON_REGISTRY[iconId];
}

/**
 * Get icon path by ID
 */
export function getIconPath(iconId: string): string | undefined {
  return ICON_REGISTRY[iconId]?.path;
}

/**
 * Get provider color
 */
export function getProviderColor(provider: IconProvider): string {
  return PROVIDER_METADATA[provider]?.color || '#6B7280';
}

/**
 * Search icons by query (searches name and tags)
 */
export function searchIcons(query: string): IconDefinition[] {
  const lowerQuery = query.toLowerCase().trim();
  if (!lowerQuery) return [];

  return Object.values(ICON_REGISTRY).filter((icon) =>
    icon.name.toLowerCase().includes(lowerQuery) ||
    icon.tags.some((tag) => tag.toLowerCase().includes(lowerQuery)) ||
    icon.id.toLowerCase().includes(lowerQuery)
  );
}

/**
 * Get all icons for a provider
 */
export function getIconsByProvider(provider: IconProvider): IconDefinition[] {
  return Object.values(ICON_REGISTRY).filter((icon) => icon.provider === provider);
}

/**
 * Get all icons for a category
 */
export function getIconsByCategory(category: string): IconDefinition[] {
  return Object.values(ICON_REGISTRY).filter((icon) => icon.category === category);
}

/**
 * Get all providers
 */
export function getAllProviders(): IconProvider[] {
  return Object.keys(PROVIDER_METADATA) as IconProvider[];
}

/**
 * Get all categories
 */
export function getAllCategories(): string[] {
  const categories = new Set<string>();
  Object.values(ICON_REGISTRY).forEach((icon) => categories.add(icon.category));
  return Array.from(categories).sort();
}

/**
 * Get random icons (for testing/demo)
 */
export function getRandomIcons(count: number = 10): IconDefinition[] {
  const allIcons = Object.values(ICON_REGISTRY);
  const shuffled = [...allIcons].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
